import {
  Box,
  CircularProgress,
  Grid,
  InputLabel,
  Modal,
  Paper,
  Typography,
} from "@mui/material";

// Import Swiper styles
import arrow from "../../../asset/popup/arrow.svg";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setJobDetaialsModal,
  setUserApplication,
} from "../../../redux/userReducer";
import "./JobDetailsModal.scss";
import CrossIcon from "../../../asset/jobs/close-circle.svg";
import star from "../../../asset/postjob/star.svg";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import graphqlRequest from "../../../requestMethod";
import ProfileList from "../ProfileList/ProfileList";
import user from "../../../asset/popup/user.webp";
import RecommendationUser from "../RecommendationUser/RecommendationUser";
import InterviewSlotInput from "../../PopUp/InterviewSlotInput/InterviewSlotInput";
import Button from "@mui/material/Button";
import { message } from "../../Common/SnakeAlert/SnakeAlert";
import moment from "moment";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
// import Typography from '@mui/material/Typography';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Avtar from "../../../asset/avtar.png";
import { useNavigate } from "react-router-dom";
import badge from "../../../asset/badge.svg";
import tickMark from "../../../asset/tickMark.svg";
import eventHelpers from "../../../Helpers/Event";
import useWindowDimensions from "../WindowDimention/windowDimention";
import MobileJobDetails from "./MobileJobDetails";
import MobileProfileDetails from "./MobileProfileDetails";
import AcceptApplicationDialog from "./AcceptApplicationDialog";
import dayjs from "dayjs";
import { pushEvent } from "../../../utils/clevertap";
const getRandomNumber = () => Math.floor(Math.random() * 5) + 1;

const JobDetailsModal = ({ handleCloseDetail, selectedData, fetchOpenJob }) => {
  let [jobDetails, setJobDetails] = useState({});
  let [applications, setApplications] = useState([]);
  let [recommendedUser, setRecommendedUser] = useState([]);
  let [recommendedUserAbsolute, setRecommendedUserAbsolute] = useState([]);
  let [selectedProfile, setSelectedProfile] = useState({});
  let [selectedRecommendedUser, setSelectedRecommendedUser] = useState({});
  // let [invitedUser, setInvitedUser] = useState({});
  let [invitedUser1, setInvitedUser1] = useState([]);
  let invitedUser = [];
  let [whetherInvitedUser, setWhetherInvitedUser] = useState([]);
  let [isInterviewSlotOpen, setIsInterviewSlotOpen] = useState(false);
  let [prevExpHandleViewMoreValue, setPrevExpHandleViewMoreValue] =
    useState(false);
  let [educationHandleViewMoreValue, setEducationHandleViewMoreValue] =
    useState(false);
  let [isresumeDownloading, setIsResumeDownloading] = useState(false);
  let [isregistrationDownloading, setIsRegistrationDownloading] =
    useState(false);

  let [isverificationDownloading, setIsVerificationDownloading] =
    useState(false);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [viewVerificationCertificate, setViewVerificationCertificate] =
    useState();

  const [openAcceptDialog, setOpenAcceptDialog] = useState(false);
  const [valueToBeMatchedState, setValueToBeMatchedState] = useState(false);

  const { AppliedUserApplication } = useSelector((state) => state.user);

  useEffect(() => {
    if (AppliedUserApplication?.length > 0) {
      const formattedApplicants = AppliedUserApplication.map((app) => ({
        id: app?.id,
        state: app?.state,
        name: app?.professional?.name?.full || "",
        email: app?.professional?.emails?.[0]?.address || "",
        phone: app?.professional?.phoneNumbers?.[0]?.number || "",
        qualification: app?.professional?.qualification?.name || "",
        experience: app?.professional?.numExperience?.name || "",
        city: app?.professional?.workCity?.name || "",
      }));

      pushEvent("Web_OpenJob_Applications_List", {
        page: "Applied Users",
        totalApplicants: formattedApplicants.length,
        applicantsData: formattedApplicants, // ✅ no stringify
      });
    }
  }, [AppliedUserApplication]);
  let dispatch = useDispatch();
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;
  console.log("accessToken", token);
  const { height, width } = useWindowDimensions();
  console.log("profile===", selectedProfile);
  console.log("data===", selectedData);

  function handleJobPost(jobType) {
    dispatch(setJobDetaialsModal());
  }
  // console.log(">>selectedRecommendedUser", selectedRecommendedUser);
  function fetchSelectedJobDetails() {
    const query = `
      {
        withAuth(token: "${token}") {
          getJob(id: "${selectedData?.id}") {
            timingsType
            id
            startTime
            nonConsequtiveTime{weekdays}
            endTime
            recommendedUsers{
              user{id},
              isApplied
            }
            campDuty
            state
            code
            shortListCount
            interviewCount
            rejectedCount
            roleOfferedCount
            jobDescription
            numberOfJobs
            numberOfDays
            organization {
              id
              name
              companyType {
                id
                name
              }
            }
            branch{
              jobLocation {
                hospitalName
                branchName
              }
            }
            department {
              id
              departmentType {
                name
              }
              branch {
                company {
                  id
                  name
                }
                brand
                subBrand
                jobLocation {
                  hospitalName
                  branchName
                }
              }
            }
            qualification {
              id
              name
              description
              profession {
                id
                name
              }
            }
           
            numExperience {
              id
              name
            }
            specialization {
              id
              name
            }
            minRate
            maxRate
            shift
            shiftLogs {
              startTime {
                ts
              }
              endTime {
                ts
              }
            }
            candidateType{
              name
            }
            contactDetail {
              address {
                address
                city
                state
              }
              email
              phone
            }
            consequtiveTime {
              start {
                ts
              }
              end {
                ts
              }
            }
            nonConsequtiveTime {
              start {
                ts
              }
              end {
                ts
              }
            }
          }
        }
      }
    `;
    graphqlRequest(query).then((response) => {
      if (response?.data?.withAuth?.getJob) {
        // console.log("jobDetails>>", response?.data?.withAuth?.getJob);

        setJobDetails(response?.data?.withAuth?.getJob);
        setWhetherInvitedUser(
          response?.data?.withAuth?.getJob?.recommendedUsers,
        );
        const { roleOfferedCount, numberOfJobs } =
          response?.data?.withAuth?.getJob;
        // if (roleOfferedCount == numberOfJobs) {
        //   // console.log({ newJobDetails: response?.data?.withAuth?.getJob });
        //   handleCloseDetail();
        // }
        // message.success("Data get successfully");
      } else {
        // message.error("Something went wrong");
      }
    });
  }
  let fetchApplications = () => {
    const query = `
      query {
        withAuth(token: "${token}") {
          listNurseApplications(job: "${selectedData?.id}") {
            id
            state
            professional{
            professionalWorkedHour
             listTopHospitals {
              name
              location
            }
             marksPercentage
               }
               professional{
                profileCompleted
                  }
            organization {
              id
              name
            }
            appliedAt {
              month
            }
            professional {
              id
              status
              name {
                salutation
                first
                full
              }
              phoneNumbers {
                number
              }
              emails {
                address
              }
              role {
                id
                name
              }
              qualification {
                name
                description
              }
            }
            rejectedAt {
              ts
            }
            rejectReason
            createdAt
            professional {
              id
              emails {
                isPrimary
                address
              }
              phoneNumbers {
                isPrimary
                number
              }
              name {
                full
              }
              address {
                state
                address
                country
                city
                country
                pin
              }
              specialization {
                name
                id
              }
              numExperience {
                id
                name
              }
              workCity {
                id
                name
              }
              qualification {
                id
                name
              }
              professionalType {
                id
                name
              }
              profile {
                dob
                gender
                pan
                aadhar
                social {
                  facebook
                  linkedin
                }
                covid
                jobHistory {
                  specialisationName
                  hospital
                  department
                  specialisation
                  start
                  end
                }
                education {
                  specialisationName
                  course
                  specialisation
                  name
                  year
                }
                references {
                  name
                  hospital
                  designation
                  phone
                  email
                }
              }
              languageKnownNew
              additionalTrainingNew
              workedOn {
                id
                softwarename
              }
              professionalRegistration {
                number
                registrationType {
                  id
                  name
                }
              }
              avatar {
                location
                fileName
                uri
                bucket
                region
                mimeType
                secureUrl
                url
                isSecured
                cdnUrl
              }
              correspondenceAddress {
                address
                city
                state
                pin
                country
              }
              departments {
                id
                name
              }
            }
            job {
              id
              code
              state
              contactDetail{
                contactPerson
                email
                phone
              }
              organization {
                id
                name
              }
              company {
                id
                name
              }
              department {
                id
                departmentType {
                  name
                }
              }
              qualification {
                id
                name
                profession{
                  name
                }
              }
              maxRate
              minRate
              specialization {
                name
                description
                id
              }
              shift
              numberOfJobs
              numberOfDays
              jobDescription
              contactDetail {
                address {
                  city
                  state
                  pin
                }
              }
              branch {
                id
                brand
                subBrand
                jobLocation {
                  hospitalName
                  branchName
                }
              }
              numExperience {
                name
                id
              }
              consequtiveTime {
                start {
                  year
                  month
                  date
                  hour
                  ts
                }
                end {
                  year
                  month
                  date
                  hour
                  ts
                }
              }
            }
          }
        }
    }
    `;
    graphqlRequest(query).then((response) => {
      console.log("listNurseApplications response", response);
      console.log(
        "BGV / professional.status",
        response?.data?.withAuth?.listNurseApplications?.map((app) => ({
          applicationId: app?.id,
          name: app?.professional?.name?.full,
          status: app?.professional?.status,
        })),
      );
      dispatch(
        setUserApplication(response.data.withAuth.listNurseApplications),
      );
      setApplications(response.data.withAuth.listNurseApplications);
      if (Object.keys(selectedProfile)?.length > 0) {
        setSelectedProfile(
          response.data.withAuth.listNurseApplications.filter(
            (data) => selectedProfile.id === data.id && data,
          )[0],
        );
      }
    });
  };

  // let fetchRecommendedUser = () => {
  //   const query = `
  //     query{
  //       getRecommendedUser(jobId:"${selectedData?.id}") {
  //         id
  //         marksPercentage
  //         avatar {
  //           url
  //         }
  //         emails {
  //           isPrimary
  //           address
  //         }
  //         phoneNumbers {
  //           isPrimary
  //           number
  //         }
  //         name {
  //           full
  //         }
  //         address {
  //           state
  //           address
  //           country
  //           city
  //           country
  //           pin
  //         }
  //         specialization {
  //           name
  //           id
  //         }
  //         numExperience {
  //           id
  //           name
  //         }
  //         workCity {
  //           id
  //           name
  //         }
  //         qualification {
  //           id
  //           name
  //         }
  //         professionalType {
  //           id
  //           name
  //         }
  //         profile {
  //           dob
  //           gender
  //           pan
  //           aadhar
  //           social {
  //             facebook
  //             linkedin
  //           }
  //           covid
  //           jobHistory {
  //             hospital
  //             department
  //             specialisation
  //             specialisationName
  //             start
  //             end
  //           }
  //           education {
  //             course
  //             specialisation
  //             specialisationName
  //             name
  //             year
  //           }
  //           references {
  //             name
  //             hospital
  //             designation
  //             phone
  //             email
  //           }
  //         }
  //         languageKnownNew
  //         additionalTrainingNew
  //         workedOn {
  //           id
  //           softwarename
  //         }
  //         professionalRegistration {
  //           number
  //           registrationType {
  //             id
  //             name
  //           }
  //         }
  //         avatar {
  //           location
  //           fileName
  //           uri
  //           bucket
  //           region
  //           mimeType
  //           secureUrl
  //           url
  //           isSecured
  //           cdnUrl
  //         }
  //         correspondenceAddress {
  //           address
  //           city
  //           state
  //           pin
  //           country
  //         }
  //         departments {
  //           id
  //           name
  //         }
  //         averageRating
  //         numberOfRatings
  //       }
  //   }
  //     `;
  //   graphqlRequest(query).then((response) => {
  //     // console.log("2>>>>>>>>>>>",response);
  //     // console.log(">>>>2>>",response.length);
  //     setRecommendedUser(response?.data?.getRecommendedUser);
  //   });
  // };

  let fetchRecommendedUser = () => {
    const query = `
      query{
        getRecommendedUser(jobId:"${selectedData?.id}") {
          absoluteMatch {
            id
            marksPercentage
            avatar {
              url
            }
              professionalWorkedHour
               listTopHospitals {
              name
              location
            }
            emails {
              isPrimary
              address
            }
            phoneNumbers {
              isPrimary
              number
            }
            name {
              full
            }
            address {
              state
              address
              country
              city
              country
              pin
            }
            specialization {
              name
              id
            }
            numExperience {
              id
              name
            }
            workCity {
              id
              name
            }
            qualification {
              id
              name
            }
            professionalType {
              id
              name
            }
            profile {
              dob
              gender
              pan
              aadhar
              social {
                facebook
                linkedin
              }
              covid
              jobHistory {
                hospital
                department
                specialisation
                start
                end
              }
              education {
                course
                specialisation
                name
                year
              }
              references {
                name
                hospital
                designation
                phone
                email
              }
            }
            languageKnownNew
            additionalTrainingNew
            workedOn {
              id
              softwarename
            }
            professionalRegistration {
              number
              registrationType {
                id
                name
              }
            }
            avatar {
              location
              fileName
              uri
              bucket
              region
              mimeType
              secureUrl
              url
              isSecured
              cdnUrl
            }
            correspondenceAddress {
              address
              city
              state
              pin
              country
            }
            departments {
              id
              name
            }
            averageRating
            numberOfRatings
          }
          similarMatch {
            id
            marksPercentage
            avatar {
              url
            }
              professionalWorkedHour
               listTopHospitals {
              name
              location
            }
            emails {
              isPrimary
              address
            }
            phoneNumbers {
              isPrimary
              number
            }
            name {
              full
            }
            address {
              state
              address
              country
              city
              country
              pin
            }
            specialization {
              name
              id
            }
            numExperience {
              id
              name
            }
            workCity {
              id
              name
            }
            qualification {
              id
              name
            }
            professionalType {
              id
              name
            }
            profile {
              dob
              gender
              pan
              aadhar
              social {
                facebook
                linkedin
              }
              covid
              jobHistory {
                hospital
                department
                specialisation
                start
                end
              }
              education {
                course
                specialisation
                name
                year
              }
              references {
                name
                hospital
                designation
                phone
                email
              }
            }
            languageKnownNew
            additionalTrainingNew
            workedOn {
              id
              softwarename
            }
            professionalRegistration {
              number
              registrationType {
                id
                name
              }
            }
            avatar {
              location
              fileName
              uri
              bucket
              region
              mimeType
              secureUrl
              url
              isSecured
              cdnUrl
            }
            correspondenceAddress {
              address
              city
              state
              pin
              country
            }
            departments {
              id
              name
            }
            averageRating
            numberOfRatings
          }
        }
    }
      `;
    graphqlRequest(query).then((response) => {
      console.log("jobDetails>>", response);
      // console.log(">>>>2>>",response.length);
      setRecommendedUser(response?.data?.getRecommendedUser?.similarMatch);
      setRecommendedUserAbsolute(
        response?.data?.getRecommendedUser?.absoluteMatch,
      );
    });
  };

  const getProfileList = () => {
    const absoluteMatchCount = recommendedUserAbsolute?.length;
    if (absoluteMatchCount >= 5) {
      return recommendedUserAbsolute.slice(0, 5);
    } else {
      const needed = 5 - absoluteMatchCount;
      return [...recommendedUserAbsolute, ...recommendedUser.slice(0, needed)];
    }
  };
  useEffect(() => {
    const profiles = getProfileList();

    if (profiles?.length > 0) {
      const formattedProfiles = profiles.map((p) => ({
        id: p?.id,
        name: p?.name?.full || "",
        email: p?.emails?.[0]?.address || "",
        phone: p?.phoneNumbers?.[0]?.number || "",
        qualification: p?.qualification?.name || "",
        experience: p?.numExperience?.name || "",
        city: p?.workCity?.name || "",
      }));

      pushEvent("Web_Suggested_List", {
        page: "Suggested Users",
        totalApplicants: formattedProfiles.length,
        applicantsData: formattedProfiles, // ✅ no stringify
      });
    }
  }, [recommendedUserAbsolute, recommendedUser]);

  const navigate = useNavigate();

  // window.history.pushState(null, null, window.location.href);
  // window.onpopstate = function () {
  //   window.history.go(1);
  // };

  useEffect(() => {
    window.location.hash = "#";
    window.location.hash = "##"; //again because google chrome don't insert first hash into history
    window.onhashchange = function () {
      window.location.hash = "#";
    };
  }, []);

  useEffect(() => {
    fetchSelectedJobDetails();
    fetchApplications();
    fetchRecommendedUser();
  }, [selectedData]);

  let handleSelect = (data) => {
    pushEvent("Web_OpenJob_Applicant_Click", {
      page: "Applied Users",
      section: "Jobs",
      applicationId: data?.id,
      state: data?.state,

      // ✅ Professional (flattened)
      userId: data?.professional?.id,
      name: data?.professional?.name?.full,
      email: data?.professional?.emails?.find((e) => e.isPrimary)?.address,
      phone: data?.professional?.phoneNumbers?.find((p) => p.isPrimary)?.number,

      profileStatus: data?.professional?.status,
      profileCompletion: data?.professional?.profileCompleted,
      experience: data?.professional?.numExperience?.name,
      qualification: data?.professional?.qualification?.name,
      specialization: data?.professional?.specialization?.name,
      city: data?.professional?.workCity?.name,
      state_user: data?.professional?.address?.state,

      registrationNumber: data?.professional?.professionalRegistration?.number,

      // ✅ Organization
      orgId: data?.organization?.id,
      orgName: data?.organization?.name,

      // ✅ Job
      jobId: data?.job?.id,
      jobCode: data?.job?.code,
      jobState: data?.job?.state,
      department: data?.job?.department?.departmentType?.name,
      jobQualification: data?.job?.qualification?.name,
      jobProfession: data?.job?.qualification?.profession?.name,
      jobSpecialization: data?.job?.specialization?.name,

      minRate: data?.job?.minRate,
      maxRate: data?.job?.maxRate,

      hospitalName: data?.job?.branch?.jobLocation?.hospitalName,

      contactPerson: data?.job?.contactDetail?.contactPerson,
      contactEmail: data?.job?.contactDetail?.email,
      contactPhone: data?.job?.contactDetail?.phone,

      jobStart: data?.job?.consequtiveTime?.start?.ts,
      jobEnd: data?.job?.consequtiveTime?.end?.ts,
    });
    setSelectedProfile(data);
    setSelectedRecommendedUser([]);
  };

  let handleRecommendedUserSelect = (data) => {
    pushEvent("Web_Recommended_Click", {
      page: "Recommended Users",
      section: "Jobs",
      userId: data?.id,
      name: data?.name?.full,
      email: data?.emails?.find((e) => e.isPrimary)?.address,
      phone: data?.phoneNumbers?.find((p) => p.isPrimary)?.number,

      specialization: data?.specialization?.name,
      experience: data?.numExperience?.name,
      city: data?.workCity?.name,
      qualification: data?.qualification?.name,
      professionalType: data?.professionalType?.name,

      rating: data?.averageRating,
    });
    setSelectedRecommendedUser(data);
    setSelectedProfile({});

    // setLink1((link1) => {
    //   return link1.filter((value, i) => i !== index);
    // });

    // invitedUser = recommendedUser.filter(
    //   (value) => {
    //     console.log(selectedRecommendedUser.id, "Main hun gian");
    //   }
    //   // value?.id !== selectedRecommendedUser.id
    // );
  };

  const [inviting, setInviting] = useState(false);
  let valueToBeMatched;

  useEffect(() => {
    if (
      whetherInvitedUser.find(
        (value) => value?.user?.id === selectedRecommendedUser.id,
      )
    ) {
      invitedUser.push({
        [selectedRecommendedUser.id]: true,
      });
      setInvitedUser1(invitedUser);
    } else {
      invitedUser.push({
        [selectedRecommendedUser.id]: false,
      });
      setInvitedUser1(invitedUser);
    }
    // console.log(whetherInvitedUser, "Hello hehe");
    // console.log(invitedUser, "Hello hehe again");

    fetchRecommendedUser();
    getVerificationAPI(selectedRecommendedUser?.id);
  }, [selectedRecommendedUser, whetherInvitedUser]);

  useEffect(() => {
    const userId = selectedProfile?.professional?.id;

    if (!userId) return;
    // console.log("userId", userId);
    getVerificationAPI(userId);
  }, [selectedProfile?.professional?.id]);

  // console.log(invitedUser1, "Hello hehe 2");

  // console.log(recommendedUser, "hello hehe 4");

  // console.log(
  //   new Date(Number(selectedRecommendedUser?.profile?.jobHistory[0]?.start)),
  //   selectedRecommendedUser?.profile?.jobHistory[0]?.start,
  //   "Main hun gian"
  // );
  // console.log(
  //   invitedUser1.map((x) => Object.keys(x).find((value) => x[value])),
  //   "Main hun gian 2"
  // );

  for (var i = 0; i <= invitedUser1.length; i++) {
    for (var key in invitedUser1[i]) {
      // console.log(invitedUser1[i][key], "o");
      valueToBeMatched = invitedUser1[i][key];
    }
  }

  // const keyToBeMatched = invitedUser1.map((x) => Object.keys(x)[0]);
  // console.log(keyToBeMatched[0], "Main hun gian 2");

  let handleReject = () => {
    let query = `
      mutation{
        mutationWithAuth(token:"${token}"){
          update{
            cancelMiniJobApplication(application:"${selectedProfile?.id}"
            )
          }
        }
      }
      `;

    graphqlRequest(query).then((response) => {
      if (response) {
        pushEvent("Web_Locum_Application_Rejected", {
          page: "Open Job",
          section: "Jobs",

          // ✅ Application
          applicationId: selectedProfile?.id,
          applicationState: selectedProfile?.state,
          createdAt: selectedProfile?.createdAt,

          // ✅ Professional (User)
          userId: selectedProfile?.professional?.id,
          name: selectedProfile?.professional?.name?.full,
          email: selectedProfile?.professional?.emails?.find((e) => e.isPrimary)
            ?.address,
          phone: selectedProfile?.professional?.phoneNumbers?.find(
            (p) => p.isPrimary,
          )?.number,

          specialization: selectedProfile?.professional?.specialization?.name,
          experience: selectedProfile?.professional?.numExperience?.name,
          qualification: selectedProfile?.professional?.qualification?.name,
          professionalType:
            selectedProfile?.professional?.professionalType?.name,

          city: selectedProfile?.professional?.workCity?.name,
          state_user: selectedProfile?.professional?.address?.state,

          profileCompletion: selectedProfile?.professional?.profileCompleted,

          // ✅ Organization
          orgId: selectedProfile?.organization?.id,
          orgName: selectedProfile?.organization?.name,

          // ✅ Job
          jobId: selectedProfile?.job?.id,
          jobCode: selectedProfile?.job?.code,
          jobState: selectedProfile?.job?.state,

          department: selectedProfile?.job?.department?.departmentType?.name,
          jobSpecialization: selectedProfile?.job?.specialization?.name,
          jobQualification: selectedProfile?.job?.qualification?.name,
          jobProfession: selectedProfile?.job?.qualification?.profession?.name,

          minRate: selectedProfile?.job?.minRate,
          maxRate: selectedProfile?.job?.maxRate,

          hospitalName: selectedProfile?.job?.branch?.jobLocation?.hospitalName,

          jobStart: selectedProfile?.job?.consequtiveTime?.start?.ts,
          jobEnd: selectedProfile?.job?.consequtiveTime?.end?.ts,
        });
        message.success("Candidate Rejected!");
        fetchApplications();
        fetchSelectedJobDetails();
      }
    });
  };

  // let handleAccept = () => {
  //   let query = `
  //     mutation{
  //       mutationWithAuth(token: "${token}")
  //       {
  //          update{
  //           approveApplicationV1(application: "${selectedProfile.id}")
  //         }
  //       }
  //     }
  //     `;

  //   graphqlRequest(query).then((response) => {
  //     console.log("acceptResponse", response);
  //     if (response) {
  //       message.success("Accept Successfully!");
  //       fetchApplications();
  //       fetchSelectedJobDetails();

  //       if (jobDetails?.numberOfJobs === jobDetails?.roleOfferedCount) {
  //         handleCloseDetail();
  //         fetchOpenJob();

  //         navigate("/locum/open-jobs");
  //       }
  //     }
  //   });
  // };

  const handleAccept = () => {
    setOpenAcceptDialog(true); // this opens the dialog
  };

  const handleDialogClose = () => {
    setOpenAcceptDialog(false);
  };

  const handleDialogConfirm = (poc) => {
    // console.log("Confirmed with POC:", poc);
    setOpenAcceptDialog(false);
    let query = `
        mutation{
          mutationWithAuth(token: "${token}")
          {
             update{
              approveApplicationV1(application: "${selectedProfile.id}")
            }
          }
        }
        `;

    graphqlRequest(query).then((response) => {
      // console.log("acceptResponse", response);
      if (response) {
        pushEvent("Web_Locum_Application_Accept", {
          page: "Open Job",
          section: "Jobs",

          // ✅ Application
          applicationId: selectedProfile?.id,
          applicationState: selectedProfile?.state,
          createdAt: selectedProfile?.createdAt,

          // ✅ Professional (User)
          userId: selectedProfile?.professional?.id,
          name: selectedProfile?.professional?.name?.full,
          email: selectedProfile?.professional?.emails?.find((e) => e.isPrimary)
            ?.address,
          phone: selectedProfile?.professional?.phoneNumbers?.find(
            (p) => p.isPrimary,
          )?.number,

          specialization: selectedProfile?.professional?.specialization?.name,
          experience: selectedProfile?.professional?.numExperience?.name,
          qualification: selectedProfile?.professional?.qualification?.name,
          professionalType:
            selectedProfile?.professional?.professionalType?.name,

          city: selectedProfile?.professional?.workCity?.name,
          state_user: selectedProfile?.professional?.address?.state,

          profileCompletion: selectedProfile?.professional?.profileCompleted,

          // ✅ Organization
          orgId: selectedProfile?.organization?.id,
          orgName: selectedProfile?.organization?.name,

          // ✅ Job
          jobId: selectedProfile?.job?.id,
          jobCode: selectedProfile?.job?.code,
          jobState: selectedProfile?.job?.state,

          department: selectedProfile?.job?.department?.departmentType?.name,
          jobSpecialization: selectedProfile?.job?.specialization?.name,
          jobQualification: selectedProfile?.job?.qualification?.name,
          jobProfession: selectedProfile?.job?.qualification?.profession?.name,

          minRate: selectedProfile?.job?.minRate,
          maxRate: selectedProfile?.job?.maxRate,

          hospitalName: selectedProfile?.job?.branch?.jobLocation?.hospitalName,

          jobStart: selectedProfile?.job?.consequtiveTime?.start?.ts,
          jobEnd: selectedProfile?.job?.consequtiveTime?.end?.ts,
        });
        message.success("Accept Successfully!");
        fetchApplications();
        fetchSelectedJobDetails();

        if (jobDetails?.numberOfJobs === jobDetails?.roleOfferedCount) {
          handleCloseDetail();
          fetchOpenJob();

          navigate("/locum/open-jobs");
        }
      }
    });
  };
  let handleShortlist = () => {
    let query = `
    mutation{
      mutationWithAuth(token: "${token}"){
        update{
          shortlistApplication(application: "${selectedProfile.id}")
        }
      }
    }
      `;

    graphqlRequest(query).then((response) => {
      if (response?.errors) {
        message?.error("Application is already shortlisted!!");
      } else {
        message.success("Shortlist Successfully!");
        fetchApplications();
        fetchSelectedJobDetails();
      }
      // if (response?.data?.withAuth?.inviteUser) {
      //   message?.success("Email has been sent");
      //   setInviting(!inviting);
      //   fetchRecommendedUser();
      //   fetchSelectedJobDetails();
      // }

      // message.success("Shortlist Successfully!");
      // fetchApplications();
      // fetchSelectedJobDetails();
    });
  };
  let handleInterview = () => {
    setIsInterviewSlotOpen(!isInterviewSlotOpen);
  };

  //action for recommandation
  //   let handlejobInvite = () => {
  //     let query = `
  //       query{
  //         withAuth(token:"${token}"){
  //           inviteUser(jobId:"${selectedData.id}",userId:"${selectedRecommendedUser.id}")
  //         }
  //       }
  //       `;
  // console.log("query====", query);
  //     graphqlRequest(query).then((response) => {
  //       if (response?.errors) {
  //         // console.log("JOD DATA", response?.errors);
  //         message?.error("Already invited!");
  //       }
  //       if (response?.data?.withAuth?.inviteUser) {
  //         message?.success("Professional Invited Successfully.");
  //         setInviting(!inviting);
  //         fetchRecommendedUser();
  //         fetchSelectedJobDetails();
  //       }
  //     });
  //   };
  let handleMultipleJobInvite = () => {
    pushEvent("Web_Invite_Apply_Job", {
      page: "Open Job",
      section: "Jobs",
      jobId: selectedData.id,

      userId: selectedRecommendedUser?.id,
      name: selectedRecommendedUser?.name?.full,
      email: selectedRecommendedUser?.emails?.find((e) => e.isPrimary)?.address,
      phone: selectedRecommendedUser?.phoneNumbers?.find((p) => p.isPrimary)
        ?.number,

      specialization: selectedRecommendedUser?.specialization?.name,
      experience: selectedRecommendedUser?.numExperience?.name,
      city: selectedRecommendedUser?.workCity?.name,
      qualification: selectedRecommendedUser?.qualification?.name,
      professionalType: selectedRecommendedUser?.professionalType?.name,
    });
    let query = `
      query{
        withAuth(token:"${token}"){
          inviteUserToMultipleJobs(jobIds: ["${selectedData.id}"],userId:"${selectedRecommendedUser?.id}")
        }
      }
      `;
    graphqlRequest(query).then((response) => {
      console.log("invite-response", response);
      if (response?.errors) {
        message?.error("Already invited!");
      }
      if (response?.data?.withAuth?.inviteUserToMultipleJobs) {
        message?.success("Professional Invited Successfully.");
        setInviting(!inviting);
        setValueToBeMatchedState(true);
        fetchRecommendedUser();
        fetchSelectedJobDetails();

        // setInvitedUser1((invitedUser1) => ({
        //   ...invitedUser1,
        //   [showProfileData.id]: true,
        // }));
      }
    });
  };

  let handleInterviewSlotClose = () => {
    setIsInterviewSlotOpen(!isInterviewSlotOpen);
  };

  const getFileExtension = (url) => {
    const parts = url.split(".");
    // console.log(">>>>>>>1>>>>>>>",parts)
    // const data1 = parts[parts.length - 1].split("?")[0];
    // console.log(">>>>>>>2>>>>>>>",data1)
    // return data1
    return parts[parts.length - 1].split("?")[0];
  };
  const handleDownLoadResume = () => {
    setIsResumeDownloading(true);
    const query1 = `{
    withAuth(token:"${token}"){
      getUser(id: "${selectedRecommendedUser?.id}"){
        documents {
          docType {
            name
          }
          files {
            secureUrl
            uri
            url
          }
        }
      }
    }
  }`;

    graphqlRequest(query1)
      .then((response) => {
        const documents = response?.data?.withAuth?.getUser?.documents || [];
        const data = documents.find((doc) => doc.docType?.name === "CV");

        if (data && data.files?.[0]?.url) {
          let linkSource = data.files[0].url;
          if (linkSource.startsWith("http://")) {
            linkSource = linkSource.replace("http://", "https://");
          }
          console.log("linkSource1", linkSource);
          fetch(linkSource)
            .then((res) => res.blob())
            .then((blob) => {
              const filename = `${
                selectedRecommendedUser.name.full
              }_resume.${getFileExtension(linkSource)}`;
              // console.log("hnadleResume,  here 1")
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = filename;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              setIsResumeDownloading(false);
            })
            .catch((error) => {
              console.error("Error downloading file:", error);
              setIsResumeDownloading(false);
              message.error("Failed to download the file.");
            });
        } else {
          // fallback to getUserPdf
          const query2 = `{
          withAuth(token:"${token}"){
            getUserPdf(id: "${selectedRecommendedUser?.id}")
          }
        }`;

          graphqlRequest(query2)
            .then((response) => {
              const data = response?.data?.withAuth?.getUserPdf;

              if (data) {
                const linkSource = `data:application/pdf;base64,${data}`;
                // console.log("hnadleResume,  here 2");
                const a = document.createElement("a");
                a.href = linkSource;
                a.download = `${selectedRecommendedUser.name.full}_resume.pdf`;
                a.click();
                message.success("Download Completed.");
              } else {
                message.error("Currently we don't have File to Download.");
              }
              setIsResumeDownloading(false);
            })
            .catch((error) => {
              console.error("Error fetching fallback PDF:", error);
              setIsResumeDownloading(false);
              message.error("Failed to fetch the fallback resume.");
            });
        }
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
        setIsResumeDownloading(false);
        message.error("Failed to fetch the resume.");
      });
  };

  const handleDownLoadResumeApplicant = (type) => {
    setIsResumeDownloading(true);

    const query1 = `{
    withAuth(token:"${token}"){
      getUser(id: "${selectedProfile?.professional?.id}"){
        documents {
          docType {
            name
          }
          files {
            secureUrl
            uri
            url
          }
        }
      }
    }
  }`;

    graphqlRequest(query1)
      .then((response) => {
        const documents = response?.data?.withAuth?.getUser?.documents || [];
        const data = documents.find((doc) => doc.docType?.name === "CV");

        if (data && data.files?.[0]?.url) {
          let linkSource = data.files[0].url;
          if (linkSource.startsWith("http://")) {
            linkSource = linkSource.replace("http://", "https://");
          }
          console.log("linkSource2", linkSource);
          fetch(linkSource)
            .then((res) => res.blob())
            .then((blob) => {
              const filename = `${
                selectedProfile?.professional?.name?.full
              }_resume.${getFileExtension(linkSource)}`;
              // console.log("here 1")
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = filename;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              setIsResumeDownloading(false);
            })
            .catch((error) => {
              console.error("Error downloading file:", error);
              setIsResumeDownloading(false);
              message.error("Failed to download the file.");
            });
        } else {
          // Fall back to getUserPdf if no CV found
          const query2 = `{
          withAuth(token:"${token}"){
            getUserPdf(id: "${selectedProfile?.professional?.id}")
          }
        }`;

          graphqlRequest(query2)
            .then((response) => {
              const data = response?.data?.withAuth?.getUserPdf;

              if (data) {
                const linkSource = `data:application/pdf;base64,${data}`;
                // console.log("here 2");
                const a = document.createElement("a");
                a.href = linkSource;
                a.download = `${selectedProfile?.professional?.name?.full}_resume.pdf`;
                a.click();
                message.success("Download Completed.");
              } else {
                message.error("Currently we don't have File to Download.");
              }
              setIsResumeDownloading(false);
            })
            .catch((error) => {
              console.error("Error fetching fallback PDF:", error);
              setIsResumeDownloading(false);
              message.error("Failed to fetch the fallback resume.");
            });
        }
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
        setIsResumeDownloading(false);
        message.error("Failed to fetch the resume.");
      });
  };

  //this is old logic for suggestion user
  // const handleViewResume = () => {
  //   // console.log("selectedRecommendedUser?.id", selectedRecommendedUser?.id);
  //   setIsResumeDownloading(true);
  //   const query1 = `{
  //   withAuth(token:"${token}"){
  //     getUser(id: "${selectedRecommendedUser?.id}"){
  //       documents {
  //         docType {
  //           name
  //         }
  //         files {
  //           secureUrl
  //           uri
  //           url
  //         }
  //       }
  //     }
  //   }
  // }`;

  //   graphqlRequest(query1)
  //     .then((response) => {
  //       const documents = response?.data?.withAuth?.getUser?.documents || [];
  //       const data = documents.find((doc) => doc.docType?.name === "CV");

  //       if (data && data.files?.[0]?.url) {
  //         let linkSource = data.files[0].url; // Use the dynamic URL from the response
  //         if (linkSource.startsWith("http://")) {
  //           linkSource = linkSource.replace("http://", "https://");
  //         }
  //         // console.log("linkSource", linkSource);

  //         // Open the custom PDF viewer in a new tab with the PDF URL as a query parameter
  //         const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
  //           linkSource,
  //         )}`;
  //         window.open(viewerUrl, "_blank");
  //         setIsResumeDownloading(false);
  //       } else {
  //         setIsResumeDownloading(false);
  //         message.error("No resume found to display.");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching resume:", error);
  //       setIsResumeDownloading(false);
  //       message.error("Failed to fetch the resume.");
  //     });
  // };

  const handleViewResume = () => {
    setIsResumeDownloading(true);

    const query1 = `{
    withAuth(token:"${token}"){
      getUser(id: "${selectedRecommendedUser?.id}"){
        documents {
          docType {
            name
          }
          files {
            secureUrl
            uri
            url
          }
        }
        professionalResume {
          manualResumeUrl
          AIResumeUrl
          resumeStatus
        }
      }
    }
  }`;

    graphqlRequest(query1)
      .then((response) => {
        const user = response?.data?.withAuth?.getUser;

        const documents = user?.documents || [];
        const professionalResume = user?.professionalResume || [];

        let linkSource = null;

        // --------------------------------------------------
        // 1. Check professionalResume first
        // --------------------------------------------------
        if (professionalResume.length > 0) {
          const activeResume = professionalResume.find(
            (resume) => resume?.resumeStatus === true,
          );

          if (activeResume) {
            // Prefer AI Resume, fallback to Manual Resume
            linkSource =
              activeResume?.AIResumeUrl ||
              activeResume?.manualResumeUrl ||
              null;
          }
        }

        // --------------------------------------------------
        // 2. Fallback to CV document
        // --------------------------------------------------
        if (!linkSource) {
          const cvDocument = documents.find(
            (doc) => doc?.docType?.name === "CV",
          );

          if (cvDocument?.files?.[0]?.url) {
            linkSource = cvDocument.files[0].url;
          }
        }

        // --------------------------------------------------
        // 3. No resume found
        // --------------------------------------------------
        if (!linkSource) {
          setIsResumeDownloading(false);
          message.error("No resume found to display.");
          return;
        }

        // --------------------------------------------------
        // 4. Ensure HTTPS
        // --------------------------------------------------
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }

        // console.log("Resume URL:", linkSource);

        // --------------------------------------------------
        // 5. Open custom PDF viewer
        // --------------------------------------------------
        const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
          linkSource,
        )}`;

        window.open(viewerUrl, "_blank");

        setIsResumeDownloading(false);
      })
      .catch((error) => {
        console.error("Error fetching resume:", error);
        setIsResumeDownloading(false);
        message.error("Failed to fetch the resume.");
      });
  };

  //this is based on old logic of applicants
  // const handleViewResumeApplicant = () => {
  //   setIsResumeDownloading(true);
  //   pushEvent("Web_Applicant_View_Resume", {
  //     page: "Open Job",
  //     section: "Jobs",

  //     // ✅ Basic user info
  //     userId: selectedProfile?.professional?.id,
  //     name: selectedProfile?.professional?.name?.full,
  //     email: selectedProfile?.professional?.emails?.find(e => e.isPrimary)?.address,
  //     phone: selectedProfile?.professional?.phoneNumbers?.find(p => p.isPrimary)?.number,

  //     // ✅ Professional info
  //     profileStatus: selectedProfile?.professional?.status,
  //     profileCompletion: selectedProfile?.professional?.profileCompleted,
  //     experience: selectedProfile?.professional?.numExperience?.name,
  //     qualification: selectedProfile?.professional?.qualification?.name,
  //     specialization: selectedProfile?.professional?.specialization?.name,
  //     professionalType: selectedProfile?.professional?.professionalType?.name,

  //     // ✅ Location
  //     city: selectedProfile?.professional?.workCity?.name,
  //     state_user: selectedProfile?.professional?.address?.state,

  //     // ✅ Registration
  //     registrationNumber: selectedProfile?.professional?.professionalRegistration?.number,
  //   });
  //   const query1 = `{
  //     withAuth(token:"${token}"){
  //       getUser(id: "${selectedProfile?.professional?.id}"){
  //         documents {
  //           docType {
  //             name
  //           }
  //           files {
  //             secureUrl
  //             uri
  //             url
  //           }
  //         }
  //       }
  //     }
  //   }`;

  //   graphqlRequest(query1)
  //     .then((response) => {
  //       const documents = response?.data?.withAuth?.getUser?.documents || [];
  //       const data = documents.find((doc) => doc.docType?.name === "CV");

  //       if (data && data.files?.[0]?.url) {
  //         let linkSource = data.files[0].url; // Use the dynamic URL from the response
  //          if (linkSource.startsWith("http://")) {
  //            linkSource = linkSource.replace("http://", "https://");
  //          }
  //         console.log("linkSource", linkSource);

  //         // Open the custom PDF viewer in a new tab with the PDF URL as a query parameter
  //         const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
  //           linkSource
  //         )}`;
  //         window.open(viewerUrl, "_blank");
  //         setIsResumeDownloading(false);
  //       } else {
  //         setIsResumeDownloading(false);
  //         message.error("No resume found to display.");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching resume:", error);
  //       setIsResumeDownloading(false);
  //       message.error("Failed to fetch the resume.");
  //     });
  // };

  const handleViewResumeApplicant = () => {
    setIsResumeDownloading(true);

    pushEvent("Web_Applicant_View_Resume", {
      page: "Open Job",
      section: "Jobs",

      // Basic user info
      userId: selectedProfile?.professional?.id,
      name: selectedProfile?.professional?.name?.full,
      email: selectedProfile?.professional?.emails?.find((e) => e.isPrimary)
        ?.address,
      phone: selectedProfile?.professional?.phoneNumbers?.find(
        (p) => p.isPrimary,
      )?.number,

      // Professional info
      profileStatus: selectedProfile?.professional?.status,
      profileCompletion: selectedProfile?.professional?.profileCompleted,
      experience: selectedProfile?.professional?.numExperience?.name,
      qualification: selectedProfile?.professional?.qualification?.name,
      specialization: selectedProfile?.professional?.specialization?.name,
      professionalType: selectedProfile?.professional?.professionalType?.name,

      // Location
      city: selectedProfile?.professional?.workCity?.name,
      state_user: selectedProfile?.professional?.address?.state,

      // Registration
      registrationNumber:
        selectedProfile?.professional?.professionalRegistration?.number,
    });

    const query1 = `{
    withAuth(token:"${token}"){
      getUser(id: "${selectedProfile?.professional?.id}"){
        documents {
          docType {
            name
          }
          files {
            secureUrl
            uri
            url
          }
        }
        professionalResume {
          manualResumeUrl
          AIResumeUrl
          resumeStatus
        }
      }
    }
  }`;

    graphqlRequest(query1)
      .then((response) => {
        const user = response?.data?.withAuth?.getUser;

        const documents = user?.documents || [];
        const professionalResume = user?.professionalResume || [];

        let linkSource = null;

        // --------------------------------------------------
        // 1. Check professionalResume first
        // --------------------------------------------------
        if (professionalResume.length > 0) {
          const activeResume = professionalResume.find(
            (resume) => resume?.resumeStatus === true,
          );

          // console.log("activeResume", activeResume)

          if (activeResume) {
            // Prefer AI Resume, fallback to Manual Resume
            linkSource =
              activeResume?.AIResumeUrl ||
              activeResume?.manualResumeUrl ||
              null;
          }
        }

        // console.log("linkSource", linkSource);

        // --------------------------------------------------
        // 2. Fallback to CV document
        // --------------------------------------------------
        if (!linkSource) {
          const cvDocument = documents.find(
            (doc) => doc?.docType?.name === "CV",
          );

          if (cvDocument?.files?.[0]?.url) {
            linkSource = cvDocument.files[0].url;
          }
        }

        // --------------------------------------------------
        // 3. No resume found
        // --------------------------------------------------
        if (!linkSource) {
          setIsResumeDownloading(false);
          message.error("No resume found to display.");
          return;
        }

        // --------------------------------------------------
        // 4. Ensure HTTPS
        // --------------------------------------------------
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }

        // console.log("Resume URL:", linkSource);

        // --------------------------------------------------
        // 5. Open PDF viewer
        // --------------------------------------------------
        const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
          linkSource,
        )}`;

        window.open(viewerUrl, "_blank");

        setIsResumeDownloading(false);
      })
      .catch((error) => {
        console.error("Error fetching resume:", error);
        setIsResumeDownloading(false);
        message.error("Failed to fetch the resume.");
      });
  };
  const handleDownloadRegistration = async () => {
    setIsRegistrationDownloading(true);

    const query = `{
      withAuth(token: "${token}") {
        getUser(id: "${selectedRecommendedUser?.id}") {
          documents {
            docType {
              name
            }
            files {
              secureUrl
              uri
              url
            }
          }
        }
      }
    }`;

    try {
      const response = await graphqlRequest(query);
      const documents = response?.data?.withAuth?.getUser?.documents || [];
      const registrationDoc = documents.find(
        (doc) => doc.docType?.name === "REGISTRATION",
      );

      if (!registrationDoc) {
        message.error("Registration document not available for download.");
        return;
      }

      let linkSource = registrationDoc.files[0].url;
      if (linkSource.startsWith("http://")) {
        linkSource = linkSource.replace("http://", "https://");
      }
      // console.log("Downloading from:", linkSource);

      if (linkSource.includes("cloudfront.net")) {
        // ✅ **CloudFront: Direct Download**
        // console.log("Using direct CloudFront download");
        const a = document.createElement("a");
        a.href = linkSource;
        a.target = "_blank";
        a.download = linkSource.split("/").pop().split("?")[0]; // Extract filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        message.success("Download Started.");
      } else if (linkSource.includes("s3.amazonaws.com")) {
        // ✅ **AWS S3: Fetch & Download**
        // console.log("Using fetch for S3 download");
        const response = await fetch(linkSource);
        const blob = await response.blob();
        const urlParts = linkSource.split(".");
        const fileExtension = urlParts[urlParts.length - 1].split("?")[0];
        const filename = `${selectedRecommendedUser?.name?.full}_registration.${fileExtension}`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        message.success("Download Completed.");
      } else {
        message.error("Invalid file URL.");
      }
    } catch (error) {
      console.error("Download error:", error);
      message.error("Download failed.");
    } finally {
      setIsRegistrationDownloading(false); // ✅ Loader stops after the download process completes
    }
  };

  const handleViewRegistration = async () => {
    setIsRegistrationDownloading(true);

    try {
      const query1 = `{
      withAuth(token:"${token}"){
        getUser(id: "${selectedRecommendedUser?.id}"){
          documents {
            docType {
              name
            }
            files {
              secureUrl
              uri
              url
            }
          }
        }
      }
    }`;

      const response = await graphqlRequest(query1);
      const documentsData = response?.data?.withAuth?.getUser?.documents || [];

      const registrationDoc = documentsData.find(
        (doc) => doc.docType?.name === "REGISTRATION",
      );

      if (!registrationDoc) {
        message.error("Registration document not available for display.");
        return;
      }

      // console.log("registrationDoc", registrationDoc);
      let linkSource = registrationDoc.files[0].url;
      // let linkSource =
      //   "https://nurse-app-jobizo.s3.amazonaws.com/uploads/96feffb5-a8fb-4214-8479-b7cf16459bc5.pdf";
      if (linkSource.startsWith("http://")) {
        linkSource = linkSource.replace("http://", "https://");
      }

      // console.log("linkSource", linkSource);

      if (
        linkSource.includes("cloudfront.net") ||
        linkSource.includes("s3.amazonaws.com")
      ) {
        const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
          linkSource,
        )}`;
        window.open(viewerUrl, "_blank");
      } else {
        message.error("No registration document found to display.");
      }
    } catch (error) {
      console.error("Error fetching registration document:", error);
      message.error(
        "Something went wrong while fetching the registration document.",
      );
    } finally {
      setIsRegistrationDownloading(false);
    }
  };

  const handleDownloadRegistrationApplication = async () => {
    setIsRegistrationDownloading(true);

    const query = `{
      withAuth(token: "${token}") {
        getUser(id: "${selectedProfile?.professional?.id}") {
          documents {
            docType {
              name
            }
            files {
              secureUrl
              uri
              url
            }
          }
        }
      }
    }`;

    try {
      const response = await graphqlRequest(query);
      const documents = response?.data?.withAuth?.getUser?.documents || [];
      const registrationDoc = documents?.find(
        (doc) => doc.docType?.name === "REGISTRATION",
      );

      if (!registrationDoc) {
        message.error("Registration document not available for download.");
        return;
      }

      let linkSource = registrationDoc.files[0].url;
      if (linkSource.startsWith("http://")) {
        linkSource = linkSource.replace("http://", "https://");
      }
      // console.log("Downloading from:", linkSource);

      if (linkSource.includes("cloudfront.net")) {
        // ✅ **CloudFront: Direct Download**
        // console.log("Using direct CloudFront download");
        const a = document.createElement("a");
        a.href = linkSource;
        a.target = "_blank";
        a.download = linkSource.split("/").pop().split("?")[0]; // Extract filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        message.success("Download Started.");
      } else if (linkSource.includes("s3.amazonaws.com")) {
        // ✅ **AWS S3: Fetch & Download**
        // console.log("Using fetch for S3 download");
        const response = await fetch(linkSource);
        const blob = await response.blob();
        const urlParts = linkSource.split(".");
        const fileExtension = urlParts[urlParts.length - 1].split("?")[0];
        const filename = `${selectedProfile?.professional?.name?.full}_registration.${fileExtension}`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        message.success("Download Completed.");
      } else {
        message.error("Invalid file URL.");
      }
    } catch (error) {
      console.error("Download error:", error);
      message.error("Download failed.");
    } finally {
      setIsRegistrationDownloading(false); // ✅ Loader stops after the download process completes
    }

    // graphqlRequest(query).then((response) => {
    //   // console.log("responseapplicant: ", response);
    //   const documents = response?.data?.withAuth?.getUser?.documents || [];
    //   const registrationDoc = documents.find(
    //     (doc) => doc.docType?.name === "REGISTRATION"
    //   );
    //   if (registrationDoc) {
    //     setIsRegistrationDownloading(false);
    //     const linkSource = registrationDoc.files[0].url;
    //       fetch(linkSource)
    //       .then((response) => response.blob())
    //       .then((blob) => {
    //         const urlParts = linkSource.split(".");
    //         const fileExtension = urlParts[urlParts.length - 1].split("?")[0];
    //         const filename = `${selectedProfile?.professional?.name?.full}_registration.${fileExtension}`;
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement("a");
    //         a.href = url;
    //         a.download = filename;
    //         document.body.appendChild(a);
    //         a.click();
    //         window.URL.revokeObjectURL(url);
    //         message.success("Download Completed.");
    //       })
    //   } else {
    //     setIsRegistrationDownloading(false);
    //     message.error("Registration document not available for download.");
    //   }
    // })
  };

  const handleViewRegistrationApplication = async () => {
    setIsRegistrationDownloading(true);
    pushEvent("Web_Applicant_View_Registration", {
      page: "Open Job",
      section: "Jobs",

      // ✅ Basic Info
      userId: selectedProfile?.professional?.id,
      name: selectedProfile?.professional?.name?.full,
      email: selectedProfile?.professional?.emails?.find((e) => e.isPrimary)
        ?.address,
      phone: selectedProfile?.professional?.phoneNumbers?.find(
        (p) => p.isPrimary,
      )?.number,

      // ✅ Professional Info
      profileStatus: selectedProfile?.professional?.status,
      profileCompletion: selectedProfile?.professional?.profileCompleted,
      experience: selectedProfile?.professional?.numExperience?.name,
      qualification: selectedProfile?.professional?.qualification?.name,
      specialization: selectedProfile?.professional?.specialization?.name,
      professionalType: selectedProfile?.professional?.professionalType?.name,

      // ✅ Location
      city: selectedProfile?.professional?.workCity?.name,
      state_user: selectedProfile?.professional?.address?.state,

      // ✅ Registration (MAIN thing for this event)
      registrationNumber:
        selectedProfile?.professional?.professionalRegistration?.number,
    });
    try {
      const query1 = `{
      withAuth(token:"${token}"){
        getUser(id: "${selectedProfile?.professional?.id}"){
          documents {
            docType {
              name
            }
            files {
              secureUrl
              uri
              url
            }
          }
        }
      }
    }`;

      const response = await graphqlRequest(query1);
      const documentsData = response?.data?.withAuth?.getUser?.documents || [];

      const registrationDoc = documentsData.find(
        (doc) => doc.docType?.name === "REGISTRATION",
      );

      if (!registrationDoc) {
        message.error("Registration document not available for display.");
        return;
      }

      // console.log("registrationDoc", registrationDoc);
      let linkSource = registrationDoc.files[0].url;
      // let linkSource =
      //   "https://nurse-app-jobizo.s3.amazonaws.com/uploads/96feffb5-a8fb-4214-8479-b7cf16459bc5.pdf";
      if (linkSource.startsWith("http://")) {
        linkSource = linkSource.replace("http://", "https://");
      }

      // console.log("linkSource", linkSource);

      if (
        linkSource.includes("cloudfront.net") ||
        linkSource.includes("s3.amazonaws.com")
      ) {
        const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
          linkSource,
        )}`;
        window.open(viewerUrl, "_blank");
      } else {
        message.error("No registration document found to display.");
      }
    } catch (error) {
      console.error("Error fetching registration document:", error);
      message.error(
        "Something went wrong while fetching the registration document.",
      );
    } finally {
      setIsRegistrationDownloading(false);
    }
  };

  const handleDownLoadVerification = () => {
    setIsVerificationDownloading(true);
    const query1 = `{
    withAuth(token:"${token}"){
      getDownloadVerification(userId: "${selectedRecommendedUser?.id}"){
       pdfUrl
      }
    }
  }`;

    graphqlRequest(query1)
      .then((response) => {
        const documents =
          response?.data?.withAuth?.getDownloadVerification || [];
        if (documents && documents.pdfUrl) {
          let linkSource = documents.pdfUrl;
          if (linkSource.startsWith("http://")) {
            linkSource = linkSource.replace("http://", "https://");
          }
          fetch(linkSource)
            .then((res) => res.blob())
            .then((blob) => {
              const filename = `${
                selectedRecommendedUser.name.full
              }_verification.${getFileExtension(linkSource)}`;
              // console.log("hnadleResume,  here 1")
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = filename;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              setIsVerificationDownloading(false);
            })
            .catch((error) => {
              setIsVerificationDownloading(false);
              message.error("Failed to view the file.");
            });
        } else {
          message.error("No verification certificate available.");
          setIsVerificationDownloading(false);
        }
      })
      .catch((error) => {
        setIsVerificationDownloading(false);
        message.error("Failed to fetch the resume.");
      });
  };

  const getVerificationAPI = async (userId) => {
    // console.log("userId2", userId);
    const query1 = `{
    withAuth(token:"${token}"){
      getDownloadVerification(userId: "${userId}"){
       pdfUrl
      }
    }
  }`;
    const response = await graphqlRequest(query1);
    // console.log("response", response);
    setViewVerificationCertificate(
      response?.data?.withAuth?.getDownloadVerification,
    );
  };

  const handleViewVerification = async () => {
    setIsVerificationDownloading(true);

    try {
      const query1 = `{
    withAuth(token:"${token}"){
      getDownloadVerification(userId: "${selectedRecommendedUser?.id}"){
       pdfUrl
      }
    }
  }`;

      const response = await graphqlRequest(query1);
      // console.log("response", response);
      const documents = response?.data?.withAuth?.getDownloadVerification || [];
      if (documents && documents.pdfUrl) {
        let linkSource = documents.pdfUrl;
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }

        const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
          linkSource,
        )}`;
        window.open(viewerUrl, "_blank");

        //  const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
        //    linkSource
        //  )}`;

        //  // Redirect to the viewer page on the same tab
        //  window.location.href = viewerUrl;
      } else {
        message.error("No verification certificate found to display.");
      }
    } catch (error) {
      console.error("Error fetching verification document:", error);
      message.error(
        "Something went wrong while fetching the verification document.",
      );
    } finally {
      setIsVerificationDownloading(false);
    }
  };

  const handleDownLoadVerificationApplication = () => {
    setIsVerificationDownloading(true);
    const query1 = `{
    withAuth(token:"${token}"){
      getDownloadVerification(userId: "${selectedProfile?.professional?.id}"){
       pdfUrl
      }
    }
  }`;

    graphqlRequest(query1)
      .then((response) => {
        const documents =
          response?.data?.withAuth?.getDownloadVerification || [];
        if (documents && documents.pdfUrl) {
          let linkSource = documents.pdfUrl;
          if (linkSource.startsWith("http://")) {
            linkSource = linkSource.replace("http://", "https://");
          }
          fetch(linkSource)
            .then((res) => res.blob())
            .then((blob) => {
              const filename = `${
                selectedProfile?.professional?.name.full
              }_verification.${getFileExtension(linkSource)}`;
              // console.log("hnadleResume,  here 1")
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = filename;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              setIsVerificationDownloading(false);
            })
            .catch((error) => {
              setIsVerificationDownloading(false);
              message.error("Failed to download the file.");
            });
        } else {
          message.error("No verification certificate available.");
          setIsVerificationDownloading(false);
        }
      })
      .catch((error) => {
        setIsVerificationDownloading(false);
        message.error("Failed to fetch the resume.");
      });
  };

  const handleViewVerificationApplication = async () => {
    setIsVerificationDownloading(true);
    pushEvent("Web_Applicant_View_Verification", {
      page: "Open Job",
      section: "Jobs",

      // ✅ Basic Info
      userId: selectedProfile?.professional?.id,
      name: selectedProfile?.professional?.name?.full,
      email: selectedProfile?.professional?.emails?.find((e) => e.isPrimary)
        ?.address,
      phone: selectedProfile?.professional?.phoneNumbers?.find(
        (p) => p.isPrimary,
      )?.number,

      // ✅ Professional Info
      profileStatus: selectedProfile?.professional?.status,
      profileCompletion: selectedProfile?.professional?.profileCompleted,
      experience: selectedProfile?.professional?.numExperience?.name,
      specialization: selectedProfile?.professional?.specialization?.name,
      qualification: selectedProfile?.professional?.qualification?.name,
      professionalType: selectedProfile?.professional?.professionalType?.name,

      // ✅ Location
      city: selectedProfile?.professional?.workCity?.name,
      state_user: selectedProfile?.professional?.address?.state,
    });
    try {
      const query1 = `{
    withAuth(token:"${token}"){
      getDownloadVerification(userId: "${selectedProfile?.professional?.id}"){
       pdfUrl
      }
    }
  }`;

      const response = await graphqlRequest(query1);
      const documents = response?.data?.withAuth?.getDownloadVerification || [];
      if (documents && documents.pdfUrl) {
        let linkSource = documents.pdfUrl;
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }

        const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(
          linkSource,
        )}`;
        window.open(viewerUrl, "_blank");
      } else {
        message.error("No verification certificate found to display.");
      }
    } catch (error) {
      console.error("Error fetching verification document:", error);
      message.error(
        "Something went wrong while fetching the verification document.",
      );
    } finally {
      setIsVerificationDownloading(false);
    }
  };
  console.log("viewVerificationCertificate", viewVerificationCertificate);

  const timeString = "14:00";
  const formattedTime = moment(timeString, "hh:mm").format("hh:a");
  function setStateColor(state) {
    if (state === "OPEN") {
      return "#FAEDCD";
    }
    if (state === "ACCEPTED") {
      return "#BBD6B8";
    }
    if (state === "REJECTED") {
      return "#FFB4B4";
    }
    if (state === "PENDING_TEST") {
      return "#FFB4B4";
    }
    if (state === "REVIEW") {
      return "#F3DEBA"; //yellow
    }
    if (state === "PENDING_INTERVIEW") {
      return "#C9EEFF";
    }
    if (state === "WITHDRAW") {
      return "#FFB4B4";
    }
  }

  // console.log(
  //   jobDetails?.numberOfJobs,
  //   "gian",
  //   "sunio",
  //   jobDetails?.roleOfferedCount
  // );

  // console.log("1---", selectedProfile?.professional);

  const fetchUserId = async () => {
    let data = localStorage.getItem("auth");
    let token = JSON.parse(data)?.accessToken;
    try {
      const query = `
    query {
      withAuth(token: "${token}"){
       userDetails{
        id,
        name {
          salutation
          first
          middle
          last
          full
        },
        emails {
          isPrimary
          isVerified
          address
        },
        phoneNumbers{
          number
        }
      }
      }
    }
      `;
      const response = await graphqlRequest(query);
      // console.log("175-->",response)
      return response;
    } catch (error) {
      console.error("Error sending GraphQL request:", error);
    }
  };

  const trackLocumPostRejected = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;
    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);
      //set event data
      window.Moengage.track_event(
        eventHelpers.LOCUM_RJCT,
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackLocumPostAccepted = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;
    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);
      //set event data
      window.Moengage.track_event(
        eventHelpers.LOCUM_ACPT,
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };
  const randomMapRef = React.useRef({});

  const getRandomForProfile = (profileId) => {
    if (!randomMapRef.current[profileId]) {
      randomMapRef.current[profileId] = Math.floor(Math.random() * 5) + 1;
    }
    return randomMapRef.current[profileId];
  };
  const rating = getRandomForProfile(selectedProfile.id);
  const trackLocumPostShortlisted = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;
    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.LOCUM_INTRV,
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackLocumPostInterview = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.LOCUM_SHRTLST,
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackInviteToApply = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.INVT_2_APPLY,
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  const trackDownloadResume = async () => {
    const user = await fetchUserId();
    // console.log("user---->", user);
    const userId = user.data.withAuth.userDetails.id;
    const userName = user.data.withAuth.userDetails.name.full;
    const userEmail = user.data.withAuth.userDetails.emails[0].address;
    const userPhone = user.data.withAuth.userDetails.phoneNumbers[0].number;

    if (window.Moengage) {
      //set unique id
      window.Moengage.add_unique_user_id(userId);
      //set user attributes
      window.Moengage.add_user_name(userName);
      window.Moengage.add_email(userEmail);
      window.Moengage.add_mobile(userPhone);

      //set event data
      window.Moengage.track_event(
        eventHelpers.DOWNLD_RESUME,
        // {
        // "ID": userId,
        // "name": userName,
        // "Email": userEmail,
        // "date": Date.now(),
        //}
      );
      // window.Moengage.destroy_session();
    }
  };

  // console.log("1047-->", jobDetails);
  console.log("1090>>>", recommendedUser);
  console.log("1091>>>", recommendedUserAbsolute);
  console.log("selectedRecommendedUser", selectedRecommendedUser);
  console.log("selectedProfile", selectedProfile);

  const hospitals = [
    {
      id: 1,
      name: "Medanta rtrtfdf  fefdfdfdf df deeeeeeeerrerffdf",
      location: "Gurgaon",
    },
    { id: 2, name: "Jaypee", location: "Noida" },
    { id: 3, name: "Max", location: "Delhi" },
  ];

  const togglePopup = (event) => {
    event.preventDefault(); // Prevent any default behavior
    event.stopPropagation(); // Stop event bubbling to parent elements
    console.log("Button Clicked! isPopupOpen:", isPopupOpen); // Debug click
    setIsPopupOpen((prev) => {
      console.log("Setting isPopupOpen to:", !prev); // Debug state change
      return !prev;
    });
  };

  const headerStyle = {
    padding: "12px 16px",
    borderBottom: "1px solid #ddd",
    textAlign: "left",
    fontWeight: "600",
    color: "#444",
  };

  const cellStyle = {
    padding: "12px 16px",
    color: "#333",
    wordBreak: "break-word",
  };

  // console.log("selectedData", selectedData);
  // console.log("applicationsData", applications);

  return (
    <div className="jobDetails-container">
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "1rem",
          // marginBottom: "20px",
          marginLeft: "auto",
          marginRight: "auto",
          width: "97%",
          flexWrap: "nowrap",
        }}
      >
        <Typography
          sx={{
            // marginLeft: "4rem",
            fontWeight: "600 !important",
            // right: "14.8rem",
            color: "#4D4D4D",
          }}
        >
          Job Summary{" "}
          {jobDetails?.timingsType === "NON_CONSEQUTIVE"
            ? "(NON CONSECUTIVE)"
            : "(CONSECUTIVE)"}
          {/* <div className="nc-display">
            {jobDetails?.timingsType === "NON_CONSEQUTIVE" ? (
              <>
                {jobDetails?.nonConsequtiveTime?.weekdays.map((data) => (
                  <p>{data}</p>
                ))}
              </>
            ) : null}
          </div> */}
        </Typography>
        {/* <HighlightOffOutlinedIcon
          sx={{ cursor: "pointer",  }}
          onClick={handleCloseDetail}
        /> */}
        <img
          src={CrossIcon}
          onClick={() => {
            handleCloseDetail();
            // fetchOpenJob();
            // navigate(0);
          }}
          style={{ cursor: "pointer" }}
        />
      </Grid>

      <Box>
        <Box
          sx={{
            // Default styles
            borderBottom: "2px solid #000",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            pb: "20px",
            mr: "10px",
            // Custom breakpoint at 1023px
            "@media (max-width: 1023px)": {
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              flexWrap: "wrap",
              gap: { xs: 2, md: 3 },
              justifyContent: "space-between",
              p: 2,
              mr: "5px",
              borderBottom: "2px solid #000",
              // pb: 3
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              paddingLeft: "20px",
              "@media (max-width: 1023px)": {
                backgroundColor: "rgba(0,0,0,0.03)",
                p: 2,
                borderRadius: 1,
                // textAlign: 'center',
                mt: { xs: 0, md: 0 },
              },
            }}
          >
            <h3
              style={{
                color: "#000",
                fontWeight: 800,
                fontSize: "16px",
                margin: "0px",
              }}
            >
              Job ID:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {selectedData.jobId}
              </span>{" "}
            </h3>
            <h3
              style={{
                color: "#000",
                fontWeight: 800,
                fontSize: "16px",
                margin: "0px",
              }}
            >
              Branch:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.branch?.jobLocation?.hospitalName}
              </span>{" "}
            </h3>
            <h3
              style={{
                color: "#000",
                fontWeight: 800,
                fontSize: "16px",
                margin: "0px",
              }}
            >
              Department:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.department?.departmentType?.name}
              </span>{" "}
            </h3>
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Experience:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.numExperience?.name}
              </span>{" "}
            </h2>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              "@media (max-width: 1023px)": {
                backgroundColor: "rgba(0,0,0,0.03)",
                p: 2,
                borderRadius: 1,
                // textAlign: 'center',
                mt: { xs: 0, md: 0 },
              },
            }}
          >
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Qualification:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.qualification?.name}
              </span>{" "}
            </h2>
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Specialization:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.specialization?.name}
              </span>{" "}
            </h2>
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Type of Professional:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.candidateType?.name}
              </span>{" "}
            </h2>
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              No. of Professionals:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.numberOfJobs}
              </span>{" "}
            </h2>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              "@media (max-width: 1023px)": {
                backgroundColor: "rgba(0,0,0,0.03)",
                p: 2,
                borderRadius: 1,
                // textAlign: 'center',
                mt: { xs: 0, md: 0 },
              },
            }}
          >
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Shift Start Date & Time :{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {/* {jobDetails?.timingsType === "CONSEQUTIVE" &&
                jobDetails?.consequtiveTime?.start?.ts &&
                !isNaN(Number(jobDetails.consequtiveTime.start.ts))
                  ? (() => {
                      const date = new Date(
                        Number(jobDetails.consequtiveTime.start.ts)
                      );
                      const dateParts = date.toDateString().split(" ");
                      if (dateParts.length >= 3) {
                        dateParts.splice(1, 0, ",");
                      }
                      return dateParts.join(" ");
                    })()
                  : jobDetails?.nonConsequtiveTime?.start?.ts &&
                    !isNaN(Number(jobDetails.nonConsequtiveTime.start.ts))
                  ? (() => {
                      const date = new Date(
                        Number(jobDetails.nonConsequtiveTime.start.ts)
                      );
                      const dateParts = date.toDateString().split(" ");
                      if (dateParts.length >= 3) {
                        dateParts.splice(1, 0, ",");
                      }
                      return dateParts.join(" ");
                    })()
                  : ""} */}
                {jobDetails?.timingsType === "CONSEQUTIVE" &&
                jobDetails?.consequtiveTime?.start?.ts &&
                !isNaN(Number(jobDetails.consequtiveTime.start.ts))
                  ? dayjs(Number(jobDetails.consequtiveTime.start.ts)).format(
                      "MMM DD YYYY, hh:mm A",
                    )
                  : jobDetails?.nonConsequtiveTime?.start?.ts &&
                      !isNaN(Number(jobDetails.nonConsequtiveTime.start?.ts))
                    ? dayjs(
                        Number(jobDetails.nonConsequtiveTime.start.ts),
                      ).format("MMM DD YYYY, hh:mm A")
                    : ""}
                {/* // ? new Date(
                  //     Number(jobDetails.consequtiveTime.start.ts)
                  //   ).toDateString().split(' ').join(', ')
                  // : jobDetails?.nonConsequtiveTime?.start?.ts &&
                  //   !isNaN(Number(jobDetails.nonConsequtiveTime.start.ts))
                  // ? new Date(
                  //     Number(jobDetails.nonConsequtiveTime.start.ts)
                  //   ).toDateString().split(' ').join(', ')
                  // : ""} */}
              </span>{" "}
            </h2>
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Shift End Date & Time:{" "}
              {/* <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.timingsType === "CONSEQUTIVE" &&
                jobDetails?.consequtiveTime?.start?.ts &&
                !isNaN(Number(jobDetails.consequtiveTime.start.ts))
                  ? (() => {
                      const date = new Date(
                        Number(jobDetails.consequtiveTime.end.ts)
                      );
                      const dateParts = date.toDateString().split(" ");
                      if (dateParts.length >= 3) {
                        dateParts.splice(1, 0, ",");
                      }
                      return dateParts.join(" ");
                    })()
                  : jobDetails?.nonConsequtiveTime?.start?.ts &&
                    !isNaN(Number(jobDetails.nonConsequtiveTime.start.ts))
                  ? (() => {
                      const date = new Date(
                        Number(jobDetails.nonConsequtiveTime.end.ts)
                      );
                      const dateParts = date.toDateString().split(" ");
                      if (dateParts.length >= 3) {
                        dateParts.splice(1, 0, ",");
                      }
                      return dateParts.join(" ");
                    })()
                  : ""} */}
              {/* // ? new Date(
                  //     Number(jobDetails.consequtiveTime.end.ts)
                  //   ).toDateString()
                  // : jobDetails?.nonConsequtiveTime?.start?.ts &&
                  //   !isNaN(Number(jobDetails.nonConsequtiveTime.start.ts))
                  // ? new Date(
                  //     Number(jobDetails.nonConsequtiveTime.end.ts)
                  //   ).toDateString()
                  // : ""} */}
              {/* </span> */}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.timingsType === "CONSEQUTIVE" &&
                jobDetails?.consequtiveTime?.start?.ts &&
                !isNaN(Number(jobDetails.consequtiveTime.start.ts))
                  ? dayjs(Number(jobDetails.consequtiveTime.end.ts)).format(
                      "MMM DD YYYY, hh:mm A",
                    )
                  : jobDetails?.nonConsequtiveTime?.start?.ts &&
                      !isNaN(Number(jobDetails.nonConsequtiveTime.start.ts))
                    ? dayjs(
                        Number(jobDetails.nonConsequtiveTime.end.ts),
                      ).format("MMM DD YYYY, hh:mm A")
                    : ""}
              </span>{" "}
            </h2>

            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Camp Duty:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.campDuty === true ? "Yes" : "No"}
              </span>{" "}
            </h2>
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              paddingRight: "20px",
              '@media (max-width: 1023px)': {
                backgroundColor: 'rgba(0,0,0,0.03)',
                p: 2,
                borderRadius: 1,
                // textAlign: 'center',
                mt: { xs: 2, md: 0 }
              }
            }}
          >
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Shift Start Time:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.startTime &&
                  moment(jobDetails.startTime, "hh:mm").isValid() &&
                  moment(jobDetails.startTime, "hh:mm").format("hh:mm A")}
              </span>{" "}
            </h2>
            <h2
              style={{
                color: "#000",
                fontWeight: 800,
                margin: "0",
                fontSize: "16px",
              }}
            >
              Shift End Time:{" "}
              <span style={{ color: "#808080", fontWeight: "400" }}>
                {jobDetails?.endTime &&
                  moment(jobDetails.endTime, "hh:mm").isValid() &&
                  moment(jobDetails.endTime, "hh:mm").format("hh:mm A")}
              </span>{" "}
            </h2>
          
          </Box> */}
        </Box>
        <Box style={{ borderBottom: "2px solid #000", padding: "5px 0" }}>
          <p
            style={{
              margin: "0",
              fontSize: "16px",
              fontWeight: "700",
              color: "#034585",
              textAlign: "center",
            }}
          >
            Complete Job Details
          </p>
        </Box>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px 0",
            borderBottom: "2px solid #000",
            flexWrap: "wrap",
          }}
        >
          <Typography sx={{ paddingLeft: "20px", fontSize: "16px !important" }}>
            Total Applicants:<span>{applications?.length}</span>
          </Typography>
          <Typography sx={{ fontSize: "16px !important" }}>
            Role Offered:<span>{jobDetails?.roleOfferedCount}</span>
          </Typography>
          {/* <Typography sx={{ fontSize: "16px !important" }}>
            Shortlisted:<span>{jobDetails?.shortListCount}</span>
          </Typography>
          <Typography sx={{ fontSize: "16px !important" }}>
            Interview Scheduled:<span>{jobDetails?.interviewCount}</span>
          </Typography> */}
          <Typography
            sx={{ paddingRight: "20px", fontSize: "16px !important" }}
          >
            Rejected:<span>{jobDetails?.rejectedCount}</span>
          </Typography>
        </div>
      </Box>

      <div className="overview-bottom">
        {width > 1024 ? (
          <>
            <div className="overview-userlist-wrapper">
              <div className="userlist-top">
                <div className="header-container">
                  <h3>Applications</h3>
                </div>
                {AppliedUserApplication?.length === 0 && (
                  <h3 style={{ textAlign: "center" }}>No Data Available</h3>
                )}
                <div className="scroll-user">
                  {AppliedUserApplication?.map((data) => {
                    return (
                      <div
                        onClick={() => {
                          handleSelect(data);
                        }}
                      >
                        {" "}
                        <ProfileList
                          selectedProfile={selectedProfile || Avtar}
                          key={data.id}
                          data={data}
                          img={user}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="userlist-bottom">
                <div className="header-container">
                  <h3>Suggested profiles</h3>
                </div>
                <div className="scroll-user">
                  {getProfileList()?.length === 0 && (
                    <h3 style={{ textAlign: "center" }}>No Data Available</h3>
                  )}
                  {getProfileList()?.map((data) => {
                    return (
                      <div onClick={() => handleRecommendedUserSelect(data)}>
                        {" "}
                        <RecommendationUser
                          key={data.id}
                          data={data}
                          img={user}
                          selectedRecommendedUser={selectedRecommendedUser}
                        />{" "}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="overview-profile-wrapper">
              {Object.keys(selectedProfile)?.length == 0 &&
                Object.keys(selectedRecommendedUser)?.length == 0 && (
                  <div
                    style={{
                      position: "relative",
                      top: "50%",
                      left: "40%",
                      fontWeight: "700",
                      width: "50%",
                    }}
                  >
                    Please select a profile to view details
                  </div>
                )}
              {/* for applied application */}
              {Object.keys(selectedProfile)?.length > 0 && (
                <>
                  <div className="profile-top">
                    <div className="ov-wrapper">
                      <h3>Profile Details</h3>
                      <div className="ov-down">
                        <div className="ov-top">
                          <div className="profileov-left">
                            <div className="dp-img">
                              {selectedProfile?.professional?.marksPercentage >=
                                60 && (
                                <div
                                  className="dp-badge-hover"
                                  data-message="Jobizo Assessment Qualified"
                                >
                                  <img src={badge} className="dp-badge" />
                                </div>
                              )}
                              <img
                                src={
                                  selectedProfile?.professional?.avatar?.url ||
                                  Avtar
                                }
                                className={
                                  selectedProfile?.professional
                                    ?.marksPercentage >= 60
                                    ? "badge-border"
                                    : ""
                                }
                              />
                            </div>

                            <div className="user-info-right">
                              <div>
                                <h3>
                                  {/* {selectedProfile?.professional?.name?.salutation}{" "} */}
                                  {selectedProfile?.professional?.name?.full}
                                  <img src={tickMark} className="dp-tickmark" />
                                </h3>

                                <button
                                  style={{
                                    color: "black",
                                    backgroundColor: `${setStateColor(
                                      selectedProfile?.state,
                                    )}`,
                                  }}
                                >
                                  {selectedProfile?.state === "OPEN"
                                    ? "APPLIED"
                                    : selectedProfile?.state ===
                                        "PENDING_INTERVIEW"
                                      ? "PENDING INTERVIEW"
                                      : selectedProfile?.state ===
                                          "PENDING_TEST"
                                        ? "PENDING_TEST"
                                        : selectedProfile?.state}
                                </button>
                              </div>
                              {/* <div className="userData-right"> */}

                              <h3>
                                <>
                                  {Array.from({
                                    length: Math.min(
                                      5,
                                      Math.max(3, rating || 0),
                                    ),
                                  }).map((_, index) => (
                                    <img key={index} src={star} alt="star" />
                                  ))}
                                </>
                              </h3>

                              {selectedProfile?.professional?.qualification
                                ?.name && (
                                <p className="user-detail">
                                  <strong>Qualification:</strong>{" "}
                                  {
                                    selectedProfile?.professional?.qualification
                                      ?.name
                                  }
                                </p>
                              )}
                              {selectedProfile?.professional?.numExperience
                                .name && (
                                <p className="user-detail">
                                  <strong>Experience:</strong>{" "}
                                  {
                                    selectedProfile?.professional?.numExperience
                                      ?.name
                                  }{" "}
                                </p>
                              )}
                              {selectedProfile?.professional?.specialization
                                ?.name && (
                                <p className="user-detail">
                                  <strong>Specialization:</strong>{" "}
                                  {
                                    selectedProfile?.professional
                                      ?.specialization?.name
                                  }
                                </p>
                              )}
                              {selectedProfile?.professional
                                ?.professionalWorkedHour != "0 hours" && (
                                <p className="user-detail">
                                  <strong>Total Locum Hours:</strong>{" "}
                                  {
                                    selectedProfile?.professional
                                      ?.professionalWorkedHour
                                  }
                                </p>
                              )}

                              {selectedProfile?.professional?.listTopHospitals
                                ?.length > 0 && (
                                <div
                                  style={{ position: "relative", zIndex: 999 }}
                                >
                                  <p style={{ margin: 0 }}>
                                    <strong>
                                      Professional Top Hospital Worked:
                                    </strong>{" "}
                                    <button
                                      type="button"
                                      onClick={togglePopup}
                                      style={{
                                        color: "#007bff",
                                        textDecoration: "underline",
                                        background: "none",
                                        border: "none",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      See Hospital Details
                                    </button>
                                  </p>

                                  {isPopupOpen && (
                                    <div
                                      style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100vw",
                                        height: "100vh",
                                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                                        zIndex: 1000,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        paddingTop: "40px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          backgroundColor: "#fff",
                                          width: "90%",
                                          maxWidth: "800px",
                                          borderRadius: "12px",
                                          overflow: "hidden",
                                          boxShadow:
                                            "0 8px 20px rgba(0,0,0,0.2)",
                                          position: "relative",
                                          maxHeight: "85vh",
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {/* Close Button */}
                                        <button
                                          onClick={togglePopup}
                                          style={{
                                            position: "absolute",
                                            top: "16px",
                                            right: "20px",
                                            fontSize: "32px",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#333",
                                          }}
                                        >
                                          ×
                                        </button>

                                        {/* Title */}
                                        <div
                                          style={{
                                            padding: "24px 20px 12px",
                                            borderBottom: "1px solid #e0e0e0",
                                            textAlign: "center",
                                          }}
                                        >
                                          <h2
                                            style={{
                                              margin: 0,
                                              fontSize: "20px",
                                            }}
                                          >
                                            Hospital List
                                          </h2>
                                        </div>

                                        {/* Table Section (no left/right padding) */}
                                        <div
                                          style={{
                                            overflowY: "auto",
                                            width: "100%",
                                          }}
                                        >
                                          <table
                                            style={{
                                              width: "100%",
                                              borderCollapse: "collapse",
                                              fontSize: "15px",
                                            }}
                                          >
                                            <thead>
                                              <tr
                                                style={{
                                                  backgroundColor: "#f7f7f7",
                                                }}
                                              >
                                                {/* <th style={headerStyle}>#</th> */}
                                                <th style={headerStyle}>
                                                  Hospital Name
                                                </th>
                                                <th style={headerStyle}>
                                                  Location
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {selectedProfile?.professional?.listTopHospitals.map(
                                                (hospital, index) => (
                                                  <tr
                                                    key={index}
                                                    style={{
                                                      borderBottom:
                                                        "1px solid #eee",
                                                    }}
                                                  >
                                                    {/* <td style={cellStyle}>
                                                      {index + 1}
                                                    </td> */}
                                                    <td style={cellStyle}>
                                                      {hospital.name}
                                                    </td>
                                                    <td style={cellStyle}>
                                                      {hospital.location}
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}

                              {/* </div> */}
                            </div>
                          </div>
                          <div className="profileov-right">
                            {selectedProfile?.state === "OPEN" && (
                              <>
                                <button
                                  className="reject"
                                  onClick={() => {
                                    handleReject();
                                    trackLocumPostRejected();
                                  }}
                                >
                                  Reject
                                </button>
                                <button
                                  className="accept"
                                  onClick={() => {
                                    handleAccept();
                                    trackLocumPostAccepted();
                                  }}
                                >
                                  Accept
                                </button>

                                {openAcceptDialog && (
                                  <AcceptApplicationDialog
                                    open={openAcceptDialog}
                                    onClose={handleDialogClose}
                                    onConfirm={handleDialogConfirm}
                                    // applicant={{
                                    //   id: applications[0]?.id,
                                    //   name: applications[0]?.professional?.name
                                    //     ?.full,
                                    //   degree:
                                    //     applications[0]?.professional
                                    //       ?.qualification?.name,
                                    //   designation:
                                    //     applications[0]?.professional
                                    //       ?.specialization?.name,
                                    //   avatar:
                                    //     applications[0]?.professional?.avatar
                                    //       ?.url || "",
                                    // }}
                                    // defaultPoc={
                                    //   applications[0]?.job?.contactDetail
                                    // }
                                    // selectedProfile
                                    applicant={{
                                      id: selectedProfile?.id,
                                      name: selectedProfile?.professional?.name
                                        ?.full,
                                      degree:
                                        selectedProfile?.professional
                                          ?.qualification?.name,
                                      designation:
                                        selectedProfile?.professional
                                          ?.specialization?.name,
                                      avatar:
                                        selectedProfile?.professional?.avatar
                                          ?.url || "",
                                    }}
                                    defaultPoc={
                                      selectedProfile?.job?.contactDetail
                                    }
                                  />
                                )}

                                {/* <button
                                  className="schedule-interview"
                                  onClick={() => {
                                    handleInterview();
                                    trackLocumPostShortlisted();
                                  }}
                                >
                                  Schedule Interview
                                </button>

                                <button
                                  className="accept"
                                  onClick={() => {
                                    handleShortlist();
                                    trackLocumPostInterview();
                                  }}
                                >
                                  Shortlist
                                </button> */}
                              </>
                            )}
                            {/* done */}
                            {selectedProfile?.state === "REJECTED" && (
                              <>
                                <button className="reject-disabled" disabled>
                                  Reject
                                </button>
                                <button className="accept-disabled" disabled>
                                  Accept
                                </button>

                                {/* <button
                                  className="schedule-interview-disabled"
                                  disabled
                                >
                                  Schedule Interview
                                </button> */}

                                {/* <button className="accept-disabled" disabled>
                                  Shortlist
                                </button> */}
                              </>
                            )}
                            {/* done */}
                            {selectedProfile?.state === "ACCEPTED" && (
                              <>
                                <button className="reject-disabled" disabled>
                                  Reject
                                </button>
                                <button className="accept-disabled" disabled>
                                  Accept
                                </button>

                                {/* <button
                                  className="schedule-interview-disabled"
                                  disabled
                                >
                                  Schedule Interview
                                </button>

                                <button className="accept-disabled" disabled>
                                  Shortlist
                                </button> */}
                              </>
                            )}
                            {/* done */}
                            {selectedProfile?.state === "PENDING_TEST" && null}
                            {selectedProfile?.state === "PENDING_INTERVIEW" && (
                              <>
                                <button
                                  className="reject"
                                  onClick={() => handleReject()}
                                >
                                  Reject
                                </button>
                                <button
                                  className="accept"
                                  onClick={() => handleAccept()}
                                >
                                  Accept
                                </button>

                                {openAcceptDialog && (
                                  <AcceptApplicationDialog
                                    open={openAcceptDialog}
                                    onClose={handleDialogClose}
                                    onConfirm={handleDialogConfirm}
                                    applicant={{
                                      id: applications[0]?.id,
                                      name: applications[0]?.professional?.name
                                        ?.full,
                                      degree:
                                        applications[0]?.professional
                                          ?.qualification?.name,
                                      designation:
                                        applications[0]?.professional
                                          ?.specialization?.name,
                                      avatar:
                                        applications[0]?.professional?.avatar
                                          ?.url || "",
                                    }}
                                    defaultPoc={
                                      applications[0]?.job?.contactDetail
                                    }
                                  />
                                )}

                                {/* <button
                                  className="schedule-interview-disabled"
                                  disabled
                                >
                                  Schedule Interview
                                </button>

                                <button className="accept-disabled" disabled>
                                  Shortlist
                                </button> */}
                              </>
                            )}
                            {selectedProfile?.state === "REVIEW" && (
                              <>
                                <button
                                  className="reject"
                                  onClick={() => handleReject()}
                                >
                                  Reject
                                </button>
                                <button
                                  className="accept"
                                  onClick={() => handleAccept()}
                                >
                                  Accept
                                </button>

                                {openAcceptDialog && (
                                  <AcceptApplicationDialog
                                    open={openAcceptDialog}
                                    onClose={handleDialogClose}
                                    onConfirm={handleDialogConfirm}
                                    applicant={{
                                      id: applications[0]?.id,
                                      name: applications[0]?.professional?.name
                                        ?.full,
                                      degree:
                                        applications[0]?.professional
                                          ?.qualification?.name,
                                      designation:
                                        applications[0]?.professional
                                          ?.specialization?.name,
                                      avatar:
                                        applications[0]?.professional?.avatar
                                          ?.url || "",
                                    }}
                                    defaultPoc={
                                      applications[0]?.job?.contactDetail
                                    }
                                  />
                                )}

                                {/* <button
                                  className="schedule-interview"
                                  onClick={() => handleInterview()}
                                >
                                  Schedule Interview
                                </button>

                                <button
                                  className="accept"
                                  onClick={() => handleShortlist()}
                                >
                                  Shortlist
                                </button> */}
                              </>
                            )}

                            {selectedProfile?.state ===
                              "SCHEDULED_INTERVIEW" && (
                              <>
                                <button
                                  className="reject"
                                  onClick={() => handleReject()}
                                >
                                  Reject
                                </button>
                                <button
                                  className="accept"
                                  onClick={() => handleAccept()}
                                >
                                  Accept
                                </button>

                                {openAcceptDialog && (
                                  <AcceptApplicationDialog
                                    open={openAcceptDialog}
                                    onClose={handleDialogClose}
                                    onConfirm={handleDialogConfirm}
                                    // applicant={{
                                    //   id: applications[0]?.id,
                                    //   name: applications[0]?.professional?.name
                                    //     ?.full,
                                    //   degree:
                                    //     applications[0]?.professional
                                    //       ?.qualification?.name,
                                    //   designation:
                                    //     applications[0]?.professional
                                    //       ?.specialization?.name,
                                    //   avatar:
                                    //     applications[0]?.professional?.avatar
                                    //       ?.url || "",
                                    // }}
                                    // defaultPoc={
                                    //   applications[0]?.job?.contactDetail
                                    // }

                                    applicant={{
                                      id: selectedProfile?.id,
                                      name: selectedProfile?.professional?.name
                                        ?.full,
                                      degree:
                                        selectedProfile?.professional
                                          ?.qualification?.name,
                                      designation:
                                        selectedProfile?.professional
                                          ?.specialization?.name,
                                      avatar:
                                        selectedProfile?.professional?.avatar
                                          ?.url || "",
                                    }}
                                    defaultPoc={
                                      selectedProfile?.job?.contactDetail
                                    }
                                  />
                                )}

                                {/* <button
                                  className="schedule-interview-disabled"
                                  onClick={() => handleInterview()}
                                >
                                  Schedule Interview
                                </button>

                                <button
                                  className="accept-disabled"
                                  onClick={() => handleShortlist()}
                                >
                                  Shortlist
                                </button> */}
                              </>
                            )}

                            {selectedProfile?.state === "FINISHED" && null}
                            {selectedProfile?.state === "WITHDRAW" && null}
                          </div>
                        </div>
                        <div style={{ padding: "30px", marginTop: "50px" }}>
                          <Accordion>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography
                                id="Applicnt_PrevExp"
                                sx={{
                                  fontWeight: "700 !important",
                                  fontSize: "22px !important",
                                }}
                              >
                                Previous Experience
                              </Typography>{" "}
                            </AccordionSummary>
                            <AccordionDetails>
                              {selectedProfile?.professional?.profile?.jobHistory?.map(
                                (item) => (
                                  <div className="previous-experience-container">
                                    {item?.hospital && (
                                      <h3
                                        style={{
                                          fontSize: "20px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {item.hospital}
                                      </h3>
                                    )}
                                    <div className="pe-info-details">
                                      <ul>
                                        {item?.department && (
                                          <li>
                                            <p style={{ fontSize: "18px" }}>
                                              Department: {item.department}
                                            </p>
                                          </li>
                                        )}
                                        {item?.specialisation && (
                                          <li>
                                            <p style={{ fontSize: "18px" }}>
                                              Specialization:{" "}
                                              {item.specialisation}
                                            </p>
                                          </li>
                                        )}

                                        {/* <hr /> */}
                                        {item?.start &&
                                          !isNaN(Number(item.start)) && (
                                            <li>
                                              <p style={{ fontSize: "18px" }}>
                                                Job Start Month/Year:{" "}
                                                {new Date(
                                                  Number(item.start),
                                                ).toLocaleDateString("en-IN", {
                                                  month: "2-digit",
                                                  year: "numeric",
                                                })}
                                              </p>
                                            </li>
                                          )}

                                        {item?.end &&
                                          !isNaN(Number(item.end)) && (
                                            <li>
                                              <p style={{ fontSize: "18px" }}>
                                                Job End Month/Year:{" "}
                                                {new Date(
                                                  Number(item.end),
                                                ).toLocaleDateString("en-IN", {
                                                  month: "2-digit",
                                                  year: "numeric",
                                                })}
                                              </p>
                                            </li>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                ),
                              )}
                            </AccordionDetails>
                          </Accordion>
                          <Accordion>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography
                                id="Applicnt_Edu"
                                sx={{
                                  fontWeight: "700 !important",
                                  fontSize: "22px !important",
                                }}
                              >
                                Education
                              </Typography>{" "}
                            </AccordionSummary>
                            <AccordionDetails>
                              {selectedProfile?.professional?.profile?.education?.map(
                                (item) => (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: "5px",
                                    }}
                                  >
                                    <ul style={{ margin: "0" }}>
                                      <li>
                                        <p
                                          style={{
                                            fontSize: "18px",
                                            fontWeight: "500",
                                          }}
                                        >
                                          {item?.name}: {item?.year}
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                ),
                              )}
                            </AccordionDetails>
                          </Accordion>
                        </div>
                        <div className="ov-bottom">
                          {/* <h3 style={{ marginTop: "5px" }}>Previous Experience1</h3> */}
                          {/* <div
                        className="pe-container"
                        style={{
                          overflowY: !prevExpHandleViewMoreValue
                            ? "hidden"
                            : "auto",
                        }}
                      >
                        {selectedProfile?.professional?.profile?.jobHistory?.map((item)=> 
                          
                          <div className="previous-experience-container">
                          <h3 style={{ fontSize: "16px" }}>{item?.hospital}</h3>
                          <div className="pe-info-details">
                            <p>{item?.specialisation}</p>
                            <hr />
                            <p>{item?.start} {item?.end}</p>
                          </div>
                        </div>
                       
                        )}
                      </div> */}
                          {/* <div className="button-view-more">
                        <button
                          onClick={() =>
                            setPrevExpHandleViewMoreValue(
                              !prevExpHandleViewMoreValue
                            )
                          }
                        >
                          {!prevExpHandleViewMoreValue
                            ? "View More"
                            : "View less"}
                          <img
                            style={{
                              transform: !prevExpHandleViewMoreValue
                                ? "rotate(0deg)"
                                : "rotate(180deg)",
                              marginInlineStart: "8px",
                            }}
                            src={arrow}
                            alt="arrow"
                          />{" "}
                        </button>
                      </div> */}
                          {/* <h3>Education</h3> */}
                          {/* <div
                        className="profile-bottom"
                        style={{
                          overflowY: !educationHandleViewMoreValue
                            ? "hidden"
                            : "auto",
                        }}
                      > */}
                          {/* <div className="previous-experience-container">
                          <div className="pe-info-details">
                           { selectedProfile?.professional?.profile?.education?.map((item)=>
                           <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "5px",
                              }}
                            >
                              <span>{item?.name}</span>
                              <span>{item?.year}</span>
                            </div>)}
                           
                          </div>
                        </div> */}

                          {/* <div className="previous-experience-container">
          <h3>Hospital Name</h3>
          <div className="pe-info-details">
            <p>Department</p>
            <hr/>
            <p>Start Date - End Date</p>
          </div>
        </div> */}
                          {/* </div> */}
                          {/* <div
                        className="button-view-more"
                        style={{ paddingBottom: "20px" }}
                      >
                        <button
                          onClick={() =>
                            setEducationHandleViewMoreValue(
                              !educationHandleViewMoreValue
                            )
                          }
                        >
                          {!educationHandleViewMoreValue
                            ? "View More"
                            : "View less"}
                          <img
                            style={{
                              transform: !educationHandleViewMoreValue
                                ? "rotate(0deg)"
                                : "rotate(180deg)",
                              marginInlineStart: "8px",
                            }}
                            src={arrow}
                            alt="arrow"
                          />{" "}
                        </button>
                      </div> */}
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              gap: "20px", // Adds spacing between buttons
                            }}
                          >
                            {/* Button 1: Download Resume */}
                            <Button
                              onClick={() =>
                                // handleDownLoadResumeApplicant("SEL_USER")
                                handleViewResumeApplicant("SEL_USER")
                              }
                              id="Downld_Resume"
                              sx={{
                                width: "310px",
                                height: "50px",
                                padding: "10px 30px",
                                marginBottom: "30px",
                              }}
                              variant="outlined"
                              disabled={isresumeDownloading}
                            >
                              {isresumeDownloading ? (
                                <CircularProgress
                                  style={{ width: "30px", height: "30px" }}
                                />
                              ) : (
                                // "Download Resume"
                                "View Resume"
                              )}
                            </Button>
                            {/* Button 2: Registration */}
                            <Button
                              onClick={() =>
                                // handleDownloadRegistrationApplication(
                                //   "SEL_USER"
                                // )
                                handleViewRegistrationApplication("SEL_USER")
                              }
                              sx={{
                                width: "310px",
                                height: "50px",
                                padding: "10px 30px",
                                marginBottom: "30px",
                              }}
                              variant="outlined"
                            >
                              {isregistrationDownloading ? (
                                <CircularProgress
                                  style={{ width: "30px", height: "30px" }}
                                />
                              ) : (
                                // "DOWNLOAD REGISTERATION CERTIFICATE"
                                "VIEW REGISTERATION CERTIFICATE"
                              )}
                            </Button>
                            {/* Button 2: Verification */}
                            {viewVerificationCertificate ? (
                              <Button
                                onClick={() =>
                                  // handleDownLoadVerificationApplication(
                                  //   "SEL_USER"
                                  // )
                                  handleViewVerificationApplication("SEL_USER")
                                }
                                sx={{
                                  width: "310px",
                                  height: "50px",
                                  padding: "10px 30px",
                                  marginBottom: "30px",
                                }}
                                variant="outlined"
                              >
                                {isverificationDownloading ? (
                                  <CircularProgress
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                ) : (
                                  // "DOWNLOAD VERIFICATION CERTIFICATE"
                                  "VIEW VERIFICATION CERTIFICATE"
                                )}
                              </Button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* for recommended user */}
              {Object.keys(selectedRecommendedUser)?.length > 0 && (
                <>
                  <div className="profile-top">
                    <div className="ov-wrapper">
                      <h3>Profile Details</h3>
                      <div className="ov-down">
                        <div className="ov-top">
                          <div className="profileov-left">
                            <div className="dp-img-User">
                              {selectedRecommendedUser?.marksPercentage >=
                                60 && (
                                <div
                                  className="dp-badge-hover-User"
                                  data-message="Jobizo Assessment Qualified"
                                >
                                  <img src={badge} className="dp-badge" />
                                </div>
                              )}
                              <img
                                src={
                                  selectedRecommendedUser?.avatar?.url || Avtar
                                }
                                className={
                                  selectedRecommendedUser?.marksPercentage >= 60
                                    ? "badge-border"
                                    : ""
                                }
                              />

                              {/* <img
                            src={selectedRecommendedUser?.avatar?.url || Avtar}
                          /> */}
                            </div>
                            <div className="user-info-right">
                              <h3 className="user-name">
                                {selectedRecommendedUser?.name?.full}
                                <img
                                  src={tickMark}
                                  alt="Verified"
                                  className="dp-tickmark-User"
                                />
                              </h3>
                              <h3>
                                <>
                                  {Array.from({
                                    length: Math.min(
                                      5,
                                      Math.max(3, rating || 0),
                                    ),
                                  }).map((_, index) => (
                                    <img key={index} src={star} alt="star" />
                                  ))}
                                </>
                              </h3>
                              {selectedRecommendedUser?.qualification?.name && (
                                <p className="user-detail">
                                  <strong>Qualification:</strong>{" "}
                                  {selectedRecommendedUser?.qualification?.name}
                                </p>
                              )}

                              {selectedRecommendedUser?.numExperience?.name && (
                                <p className="user-detail">
                                  <strong>Experience:</strong>{" "}
                                  {selectedRecommendedUser?.numExperience?.name}
                                </p>
                              )}

                              {selectedRecommendedUser?.specialization
                                ?.name && (
                                <p className="user-detail">
                                  <strong>Specialization:</strong>{" "}
                                  {
                                    selectedRecommendedUser?.specialization
                                      ?.name
                                  }
                                </p>
                              )}

                              {selectedRecommendedUser?.professionalWorkedHour !=
                                "0 hours" && (
                                <p className="user-detail">
                                  <strong>Total Locum Hours:</strong>{" "}
                                  {
                                    selectedRecommendedUser.professionalWorkedHour
                                  }
                                </p>
                              )}
                              {selectedRecommendedUser?.listTopHospitals
                                ?.length > 0 && (
                                <div
                                  style={{ position: "relative", zIndex: 999 }}
                                >
                                  <p style={{ margin: 0 }}>
                                    <strong>
                                      Professional Top Hospital Worked:
                                    </strong>{" "}
                                    <button
                                      type="button"
                                      onClick={togglePopup}
                                      style={{
                                        color: "#007bff",
                                        textDecoration: "underline",
                                        background: "none",
                                        border: "none",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      See Hospital Details
                                    </button>
                                  </p>

                                  {isPopupOpen && (
                                    <div
                                      style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100vw",
                                        height: "100vh",
                                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                                        zIndex: 1000,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        paddingTop: "40px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          backgroundColor: "#fff",
                                          width: "90%",
                                          maxWidth: "800px",
                                          borderRadius: "12px",
                                          overflow: "hidden",
                                          boxShadow:
                                            "0 8px 20px rgba(0,0,0,0.2)",
                                          position: "relative",
                                          maxHeight: "85vh",
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {/* Close Button */}
                                        <button
                                          onClick={togglePopup}
                                          style={{
                                            position: "absolute",
                                            top: "16px",
                                            right: "20px",
                                            fontSize: "32px",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#333",
                                          }}
                                        >
                                          ×
                                        </button>

                                        {/* Title */}
                                        <div
                                          style={{
                                            padding: "24px 20px 12px",
                                            borderBottom: "1px solid #e0e0e0",
                                            textAlign: "center",
                                          }}
                                        >
                                          <h2
                                            style={{
                                              margin: 0,
                                              fontSize: "20px",
                                            }}
                                          >
                                            Hospital List
                                          </h2>
                                        </div>

                                        {/* Table Section (no left/right padding) */}
                                        <div
                                          style={{
                                            overflowY: "auto",
                                            width: "100%",
                                          }}
                                        >
                                          <table
                                            style={{
                                              width: "100%",
                                              borderCollapse: "collapse",
                                              fontSize: "15px",
                                            }}
                                          >
                                            <thead>
                                              <tr
                                                style={{
                                                  backgroundColor: "#f7f7f7",
                                                }}
                                              >
                                                {/* <th style={headerStyle}>#</th> */}
                                                <th style={headerStyle}>
                                                  Hospital Name
                                                </th>
                                                <th style={headerStyle}>
                                                  Location
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {selectedRecommendedUser?.listTopHospitals.map(
                                                (hospital, index) => (
                                                  <tr
                                                    key={index}
                                                    style={{
                                                      borderBottom:
                                                        "1px solid #eee",
                                                    }}
                                                  >
                                                    {/* <td style={cellStyle}>
                                                      {index + 1}
                                                    </td> */}
                                                    <td style={cellStyle}>
                                                      {hospital.name}
                                                    </td>
                                                    <td style={cellStyle}>
                                                      {hospital.location}
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            {/* <div className="user-info-right">
                              <h3>
                                {selectedRecommendedUser?.name?.full}
                                <img
                                  src={tickMark}
                                  className="dp-tickmark-User"
                                />
                              </h3>
                              <div>
                                <p
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  Qualification:
                                  <p>
                                    {
                                      selectedRecommendedUser?.qualification
                                        ?.name
                                    }
                                  </p>
                                </p>
                                <p
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  Experience:
                                  <span>
                                    {
                                      selectedRecommendedUser?.numExperience
                                        ?.name
                                    }
                                  </span>
                                </p>
                                {/* <p
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              Gender:
                              <span>
                                {selectedRecommendedUser?.profile?.gender}
                              </span>
                            </p> 
                              </div>
                            </div> */}
                          </div>
                          {valueToBeMatched === true ||
                          valueToBeMatchedState ? (
                            <div className="profileov-right">
                              <button className="invite-sent" disabled>
                                Invited
                              </button>
                            </div>
                          ) : (
                            <div className="profileov-right">
                              <button
                                id="Invt_2_Apply"
                                className="schedule-interview-invite"
                                onClick={() => {
                                  handleMultipleJobInvite();
                                  trackInviteToApply();
                                }}
                              >
                                Invite to Apply
                              </button>
                            </div>
                          )}
                        </div>
                        <div>
                          <div style={{ padding: "30px", marginTop: "50px" }}>
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "700 !important",
                                    fontSize: "22px !important",
                                  }}
                                >
                                  Previous Experience
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                {selectedRecommendedUser?.profile?.jobHistory?.map(
                                  (item) => (
                                    <div className="previous-experience-container">
                                      {item?.hospital && (
                                        <h3
                                          style={{
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {item.hospital}
                                        </h3>
                                      )}
                                      <div className="pe-info-details">
                                        <ul>
                                          {item?.department && (
                                            <li>
                                              <p style={{ fontSize: "18px" }}>
                                                Department: {item.department}
                                              </p>
                                            </li>
                                          )}
                                          {item?.specialisation && (
                                            <li>
                                              <p style={{ fontSize: "18px" }}>
                                                Specialization:{" "}
                                                {item.specialisation}
                                              </p>
                                            </li>
                                          )}

                                          {/* <hr /> */}
                                          {item?.start &&
                                            !isNaN(Number(item.start)) && (
                                              <li>
                                                <p style={{ fontSize: "18px" }}>
                                                  Job Start Month/Year:{" "}
                                                  {new Date(
                                                    Number(item.start),
                                                  ).toLocaleDateString(
                                                    "en-IN",
                                                    {
                                                      month: "2-digit",
                                                      year: "numeric",
                                                    },
                                                  )}
                                                </p>
                                              </li>
                                            )}

                                          {item?.end &&
                                            !isNaN(Number(item.end)) && (
                                              <li>
                                                <p style={{ fontSize: "18px" }}>
                                                  Job End Month/Year:{" "}
                                                  {new Date(
                                                    Number(item.end),
                                                  ).toLocaleDateString(
                                                    "en-IN",
                                                    {
                                                      month: "2-digit",
                                                      year: "numeric",
                                                    },
                                                  )}
                                                </p>
                                              </li>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  ),
                                )}
                              </AccordionDetails>
                            </Accordion>
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "700 !important",
                                    fontSize: "22px !important",
                                  }}
                                >
                                  Education
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                {selectedRecommendedUser?.profile?.education?.map(
                                  (item) => (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "5px",
                                      }}
                                    >
                                      <ul style={{ margin: "0" }}>
                                        <li>
                                          <span
                                            style={{
                                              fontSize: "18px",
                                              fontWeight: "500",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            {item?.name}:
                                          </span>
                                          <span
                                            style={{
                                              fontSize: "18px",
                                              fontWeight: "500",
                                            }}
                                          >
                                            {item?.year}
                                          </span>{" "}
                                        </li>
                                      </ul>
                                    </div>
                                  ),
                                )}
                              </AccordionDetails>
                            </Accordion>
                          </div>
                          <div></div>
                        </div>
                        <div className="ov-bottom">
                          {/* <h3 style={{ marginTop: "5px" }}>Previous Experience</h3>
                      <div
                        className="pe-container"
                        style={{
                          overflowY: !prevExpHandleViewMoreValue
                            ? "hidden"
                            : "auto",
                        }}
                      >

                       { selectedRecommendedUser?.profile?.jobHistory?.map((item)=>
                       <div className="previous-experience-container">
                          <h3 style={{ fontSize: "16px" }}>{item?.hospital}</h3>
                          <div className="pe-info-details">
                            <p>{item?.specialisation}</p>
                            <hr />
                            <p>{item?.start} "" {item?.end}</p>
                          </div>
                        </div>)}

                      </div> */}
                          {/* <div className="button-view-more">
                        <button
                          onClick={() =>
                            setPrevExpHandleViewMoreValue(
                              !prevExpHandleViewMoreValue
                            )
                          }
                        >
                          {!prevExpHandleViewMoreValue
                            ? "View More"
                            : "View less"}
                          <img
                            style={{
                              transform: !prevExpHandleViewMoreValue
                                ? "rotate(0deg)"
                                : "rotate(180deg)",
                              marginInlineStart: "8px",
                            }}
                            src={arrow}
                            alt="arrow"
                          />{" "}
                        </button>
                      </div> */}

                          {/* <h3>Education</h3>
                      <div
                        className="profile-bottom"
                        style={{
                          overflowY: !educationHandleViewMoreValue
                            ? "hidden"
                            : "auto",
                        }}
                      >
                        <div className="previous-experience-container">
                          <div className="pe-info-details">
                            {selectedRecommendedUser?.profile?.education?.map((item)=>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "5px",
                              }}
                            >
                              <span>{item?.name}</span>
                              <span>{item?.year}</span>
                            </div>)}
                           
                          </div>
                        </div>

                        
                      </div> */}
                          {/* <div
                        className="button-view-more"
                        style={{ paddingBottom: "20px" }}
                      >
                        <button
                          onClick={() =>
                            setEducationHandleViewMoreValue(
                              !educationHandleViewMoreValue
                            )
                          }
                        >
                          {!educationHandleViewMoreValue
                            ? "View More"
                            : "View less"}
                          <img
                            style={{
                              transform: !educationHandleViewMoreValue
                                ? "rotate(0deg)"
                                : "rotate(180deg)",
                              marginInlineStart: "8px",
                            }}
                            src={arrow}
                            alt="arrow"
                          />{" "}
                        </button>
                      </div> */}

                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              gap: "20px",
                            }}
                          >
                            <Button
                              onClick={() => {
                                // handleDownLoadResume("REC_USER");
                                handleViewResume("REC_USER");
                                trackDownloadResume();
                              }}
                              sx={{
                                width: "310px",
                                height: "50px",
                                padding: "10px 30px",
                                marginBottom: "30px",
                              }}
                              variant="outlined"
                            >
                              {isresumeDownloading ? (
                                <CircularProgress
                                  style={{ width: "30px", height: "30px" }}
                                />
                              ) : (
                                // "Download Resume"
                                "View Resume"
                              )}
                            </Button>

                            <Button
                              onClick={() =>
                                // handleDownloadRegistration("REC_USER")
                                handleViewRegistration("REC_USER")
                              }
                              sx={{
                                width: "310px",
                                height: "50px",
                                padding: "10px 30px",
                                marginBottom: "30px",
                              }}
                              variant="outlined"
                            >
                              {isregistrationDownloading ? (
                                <CircularProgress
                                  style={{ width: "30px", height: "30px" }}
                                />
                              ) : (
                                // "DOWNLOAD REGISTERATION CERTIFICATE"
                                "VIEW REGISTERATION CERTIFICATE"
                              )}
                            </Button>
                            {viewVerificationCertificate ? (
                              <Button
                                onClick={() =>
                                  // handleDownLoadVerification("REC_USER")
                                  handleViewVerification("REC_USER")
                                }
                                sx={{
                                  width: "310px",
                                  height: "50px",
                                  padding: "10px 30px",
                                  marginBottom: "30px",
                                }}
                                variant="outlined"
                              >
                                {isverificationDownloading ? (
                                  <CircularProgress
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                ) : (
                                  // "DOWNLOAD VERIFICATION CERTIFICATE"
                                  "VIEW VERIFICATION CERTIFICATE"
                                )}
                              </Button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        ) : (
          <MobileJobDetails
            applications={applications}
            recommendedUsers={{
              absoluteMatch: recommendedUserAbsolute,
              similarMatch: recommendedUser,
            }}
            selectedProfile={selectedProfile}
            selectedData={selectedData}
            selectedRecommendedUser={selectedRecommendedUser}
            handleSelect={handleSelect}
            handleRecommendedUserSelect={handleRecommendedUserSelect}
            jobDetails={jobDetails}
          />
        )}
      </div>
      <Modal
        // open={true}
        open={isInterviewSlotOpen}
        onClose={handleInterviewSlotClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <InterviewSlotInput
          fetchSelectedJobDetails={fetchSelectedJobDetails}
          handleInterviewSlotClose={handleInterviewSlotClose}
          fetchApplications={fetchApplications}
          selectedProfile={selectedProfile}
          jobDetails={jobDetails}
        />
      </Modal>
    </div>
  );
};

export default JobDetailsModal;
